// 葡萄牙

export default {
    borrow: {
        // Empréstimo de moeda apenas em inglês e indonésio. Outras línguas serão substituídas pelo inglês.
        Bo1: 'Empréstimo',
        Bo2: 'Ajudando você a explorar mais oportunidades de negociação e produtos financeiros.',
        Bo3: 'Regras de empréstimo de moeda',
        Bo4: 'Se',
        Bo5: 'Devolução dentro de dias: A taxa de juros fixa para o ciclo é',
        Bo6: 'Pagamentos diários atrasados serão cobrados para pagamentos em atraso.',
        Bo7: 'Juros de penalidade. Recomendo que você considere cuidadosamente sua capacidade de reembolsar antes de pegar moedas emprestadas para evitar taxas adicionais desnecessárias.',
        Bo8: 'Cancelar',
        Bo9: 'Confirmar',
        Bo10: 'Devolver moedas',
        Bo11: 'Nota: O endereço de depósito e o endereço de reembolso são diferentes. Para evitar erros operacionais, certifique-se de reembolsar para o endereço correto.',
        Bo12: 'Endereço da carteira:',
        Bo13: 'Devolvido para revisão.',
        Bo14: 'Razão da rejeição:',
        Bo15: 'Continuar editando',
        Bo16: 'Em análise - Envio bem-sucedido. Nossa equipe revisará sua solicitação de empréstimo em até 24 horas. Por favor, volte para verificar atualizações.',
        Bo17: 'Aprovado - Valor do empréstimo de',
        Bo18: 'Você pode verificar os detalhes em sua conta de moedas.',
        Bo19: 'Dias emprestados',
        Bo20: 'Valor devido',
        Bo21: 'Incluindo juros',
        Bo22: 'Reembolso com um clique',
        Bo23: 'Informações do Empréstimo',
        Bo24: 'Nome do Banco',
        Bo25: 'Número do Cartão Bancário',
        Bo26: 'Valor desejado do empréstimo (USDT)',
        Bo27: 'Identificação pessoal',
        Bo28: 'Cartão de Identidade (Frente & Verso)',
        Bo29: 'Clique para carregar',
        Bo30: 'Nome Completo',
        Bo31: 'Número de Telefone Principal',
        Bo32: 'Número de Identidade',
        Bo33: 'Endereço registrado',
        Bo34: 'Endereço residencial atual',
        Bo35: 'Comprovação de informações do fiador',
        Bo36: 'Nome completo do fiador',
        Bo37: 'Número de telefone',
        Bo38: 'Relação com o cliente',
        Bo39: 'Endereço residencial',
        Bo40: 'Comprovante de Renda (Dica: Você pode carregar holerites, certificados do empregador, etc.)',
        Bo41: 'Certificado de Renda',
        Bo42: 'Comprovante de Patrimônio (Dica: Você pode carregar certificados de propriedade, comprovantes de veículos, comprovantes de depósito, etc.)',
        Bo43: 'Comprovante de Patrimônio',
        Bo44: 'Outros Documentos',
        Bo45: 'informações do empréstimo',
        Bo46: 'Por favor, carregue a frente e o verso do seu cartão de identidade.',
        Bo47: 'Por favor, carregue o comprovante de renda.',
        Bo48: 'Por favor, carregue o comprovante de patrimônio.',
        Bo49: 'Usuário pedindo moedas emprestadas',

        Bo50: 'Lista de devoluções',
        Bo51: 'O empréstimo envolve riscos, e o resultado final está sujeito à análise real.',
        Bo52: 'Por que escolher o Empréstimo?',
        Bo53: 'Aprovação rápida, juros e taxas transparentes',
        Bo54: 'Por favor, escolha o banco de empréstimo.',
        Bo55: 'Empréstimo bancário direto, sem garantia necessária.',
        Bo56: 'Histórico',
        Bo57: 'Mnemônico',
        Bo58: 'O mnemônico pode ser usado para login no aplicativo.',
        Bo59: 'Gerar',
        Bo60: 'Visualizar',
        Bo61: 'Copiar',
        Bo62: 'Infelizmente',
        Bo63: 'Não desanime, ajuste sua estratégia e tente novamente!',
        Bo64: 'Parabéns',
        Bo65: 'Bom presságio! Continue com o bom trabalho e conquiste ainda mais.',
        Bo66: 'Continue fazendo pedidos',
        Bo67: 'Para garantir a segurança de seus fundos, preste atenção especial às seguintes precauções de reembolso:',
        Bo68: '1. Use apenas o endereço de reembolso oficial fornecido pela plataforma: Qualquer endereço de reembolso obtido de fontes fora dos canais oficiais da plataforma é inválido.',
        Bo69: '2. Tenha cuidado com golpes: Se alguém entrar em contato com você pessoalmente e fornecer um suposto endereço de reembolso, não confie nele facilmente.',
        Bo70: '3. Responsabilidade pela segurança do fundo: Se os fundos forem perdidos devido ao uso do endereço de reembolso errado, a plataforma não será responsável e pode buscar responsabilidades legais relevantes de acordo com a lei.',
        Bo71: 'Por favor, esteja alerta e garanta que as operações de reembolso sejam realizadas por meio de canais formais para proteger efetivamente a segurança de sua propriedade!',
        Bo72: 'Aviso de Segurança',
        Bo73: 'Entendi',
        Bo74: 'Sua conta atual é uma conta virtual, e todos os fundos na conta são apenas para negociação simulada e não podem ser usados para operações de saque reais. Fique vigilante e se proteja contra riscos relacionados!',

    },
    other: {
        back_order: 'Avisos de retirada',
        review_failed: 'A análise falhou',
        try_again: 'por favor, tente novamente',
    },
    withdraw: {
        memoTip: 'Por favor, preencha o memorando.',
        memoWar: 'Procure a cópia na página de depósito.',
    },
    findPwd: {
        code: 'código',
    },
    Purchase: {
        Pu1: 'Compra',
        Pu2: 'Selecionar pagamento',
        Pu3: 'Selecione um método de pagamento',
        Pu4: 'Confirmar pedido',
        Pu5: 'Recebido',
        Pu6: 'saldo',
        Pu7: 'quantidade de compra',
        Pu8: 'o valor',
        Pu9: 'a quantidade vendida',
        Pu10: 'Tudo',
        Pu11: 'O mínimo não pode ser inferior a',
        Pu12: 'O máximo não pode ser superior a',
        Pu13: 'Preço indicativo',
        Pu14: 'grátis',
        Pu15: 'Compre agora',
        Pu16: 'Venda agora',
        Pu17: 'comprar',
        Pu18: 'vender',
        Pu19: 'Selecione um método de pagamento',
        Pu20: 'Métodos de Pagamento',
        Pu21: 'Adicionar um método de pagamento',
        Pu22: 'Adicionar',
        Pu23: 'nome de usuário',
        Pu24: 'Número do cartão bancário',
        Pu25: 'Código IFSC',
        Pu26: 'telefone',
        Pu27: 'Confirmar',
        Pu28: 'Confirmar pedido',
        Pu29: 'Uau!',
        Pu30: 'Você fez uma retirada com sucesso.',
        Pu31: 'Status',
        Pu32: 'Concluído',
        Pu33: 'Valor recebido',
        Pu34: 'Comprar',
        Pu35: 'Vender',
        Pu36: 'Nome da moeda',
        Pu37: 'Valor total da transação',
        Pu38: 'Quantidade',
        Pu39: 'Preço',
        Pu40: 'Status',
        Pu41: 'Tempo',
        Pu42: 'Preço',
        Pu43: 'Bem-sucedido',
        Pu44: 'Falhou',
        Pu45: 'Em processamento',
        Pu46: 'Expirado',
        Pu47: 'Rejeitar',
        Pu48: 'de',
        Pu49: 'Site oficial',
        Pu50: 'Livro Branco',
        Pu51: 'Introdução',
        Pu52: 'Link do site oficial',
    },
    nhome: {
        Nh1: 'Uma das maiores exchanges de criptomoedas do mundo',
        Nh2: 'Recrutou mais de um milhão de usuários registrados na plataforma, com um volume diário de negociação superior a 10 bilhões de USDT. Ao se juntar a nós, você também negocia como um trader mestre para um investimento fácil.',
        Nh3: 'Volume de negociação',
        Nh4: 'usuários',
        Nh5: 'Produtos e serviços diversificados',
        Nh6: '- Escolha mais serviços e explore possibilidades infinitas',
        Nh7: 'Negociação de futuros',
        Nh8: 'Negociação à vista',
        Nh9: 'Negociação de opções',
        Nh10: 'Negociação fiduciária',
        Nh11: 'A maior taxa de fluxo, a menor taxa de pedido, novos projetos de moedas de alta qualidade com excelente liquidez.',
        Nh12: 'Oferece centenas de serviços de negociação de moedas de alta qualidade, seguros e confiáveis, com as taxas de transação mais baixas do mercado.',
        Nh13: 'O maior número de participantes, jogo justo, altas chances.',
        Nh14: 'Compra rápida de moedas com um clique fornece a você um sistema de negociação em tempo real eficiente e conveniente. Seus fundos podem entrar e sair em segundos.',
        Nh15: 'Tendência de mercado',
        Nh16: 'mais',
        Nh17: 'Nossas vantagens',
        Nh18: 'O sistema de controle de risco de segurança líder mundial',
        Nh19: 'Proteção completa dos ativos do usuário',
        Nh20: '—— É sua plataforma confiável.',
        Nh21: 'Modo de armazenamento offline',
        Nh22: 'Criptografia multifatorial',
        Nh23: 'Monitoramento da plataforma 24 horas por dia, 7 dias por semana.',
        Nh24: 'Uma plataforma líder de negociação de ativos digitais',
        Nh25: '—— Serviços abundantes de negociação de ativos digitais e gerenciamento de ativos para atender às diversas necessidades de negociação.',
        Nh26: 'Comece a negociar a qualquer hora, em qualquer lugar.',
        Nh27: 'Suporte completo para sistemas IOS e Android.',
        Nh28: 'Escaneie o código QR para baixar.',
        Nh29: 'Gráfico de crescimento',
        Nh30: 'Lista de declínio',
        Nh31: 'Lista de volume de transações',
        Nu32: 'Plataforma líder global de negociação de ativos digitais',

        Nu33: '- Serviços ricos de negociação de ativos digitais e gerenciamento de ativos para atender às necessidades diversificadas de negociação.',

        Nu34: 'Comece a negociar e experimente a melhor jornada de criptomoedas.',

        Nu35: 'O comprimento mínimo não deve ser inferior a 5.',
        Nu36: 'Compra rápida de moedas',
        Nu37: 'Comprar moedas',
        Nu38: '1. Uma única transação de 300W-1 bilhão IDR.',
        Nu39: '2. Após receber a conta de pagamento, conclua a transferência dentro do tempo especificado. Se ultrapassar o tempo especificado, entre em contato com o suporte ao cliente para confirmar se o pedido é válido.',
        Nu40: '3. Ao concluir a transferência, forneça a conta de transação ou UID da conta, bem como uma captura de tela detalhada da transferência e identificação pessoal válida.',
        Nu41: 'Clique para saber.',
    },
    common: {
        logins: 'Entrando...',
        login: 'Entrar',
        register: 'Registrar',
        loginregister: "Entrar/Registrar",
        logout: 'Sair',
        tip: 'Dica',
        logintip: 'por favor, entre primeiro',
        expect: 'Ansioso por expectativa!',
        delete: 'Você confirma a exclusão?',
        nodata: 'Sem dados',
        set: 'Definir',
        update: 'Modificar',
        slogan: "As 50 maiores exchanges de moeda digital do mundo.",
        subslogan: "Agência estatal garante a segurança dos ativos.",
        more: "Mais",
        please: "Por favor",
        nodata: "Sem registros",
        pleaseselect: "Selecionar",
        searchplaceholder: "Digite o símbolo da moeda...",
        searchplaceholderswap: "Digite o símbolo do swap...",
        loading: "Carregando...",
        close: "Fechar",
        ok: "OK",
        fillComplete: "Por favor, preencha todas as informações.",
    },
    header: {
        index: 'Início',
        otc: 'OTC',
        exchange: 'Spot',
        xiaoxi: 'Mensagem',
        kefu: 'Ajuda',
        login: 'ENTRAR',
        register: 'REGISTRAR',
        asset: 'ATIVO',
        otcOrder: 'PEDIDO',
        ucenter: 'CONTA',
        service: 'Anúncio',
        downloadapp: "Escaneie o código para download e instalação.",
        appdownlaod: 'Baixar APP',
        usercenter: "Centro do Usuário",
        helpcenter: "CENTRO DE AJUDA",
        aboutus: "Sobre nós",
        partner: "Parceiro",
        bzb: "Ecossistema BZB",
        assetmanage: "Finanças",
        trademanage: "Negociação",
        activity: "Relâmpago",
        lab: "Laboratório BIPPAX",
        ctc: "Troca C2C",
        labdetail: "Laboratório Relâmpago BIPPAX",
        invite: "Parceiro de Promoção",
        whitepaper: "Livro Branco",
        scandownload: "Baixar App",
        innovationmanage: "Inovação",
        swap1: "Contrato",
        swap2: "Troca(Ex)",
        swap3: "CFD",
        swap4: "Segundo",
        cexchange: "Troca Rápida",
        option: "Contrato de Opção",
        news: "Notícias",
    },
    sectionPage: {
        ptaqTitle: 'Segurança da Plataforma',
        ptaqContent: "O algoritmo de hash é usado para criptografar a autenticação de segurança líder mundial",
        ptslTitle: 'Força da Plataforma',
        ptslContent: "A maior plataforma de negociação de Bitcoin do mundo",
        newsTitle: 'Centro de Notícias',
        brandTitle: "Sobre a BIPPAX",
        brandDetail: "Honestidade  |  Justiça  |  Entusiasmo  |  Abertura",
        brandDesc1: "A BIPPAX foi fundada por um grupo de participantes e geeks pioneiros do Bitcoin. Os membros principais da equipe vêm de empresas renomadas como Google, Microsoft, Alibaba, Tencent e outras. Possui uma profunda força em pesquisa e desenvolvimento, além de ampla experiência na operação de produtos da Internet.",
        brandDesc2: "A BIPPAX é um provedor de serviços básicos em blockchain, dedicada a oferecer uma plataforma de negociação de ativos criptografados de alta qualidade para usuários globais, aderindo ao princípio básico de 'NÃO SER MALÉFICO', prestando serviços honestos, justos e entusiásticos aos clientes, e recebendo de braços abertos todos os parceiros/projetos que beneficiem os interesses fundamentais dos usuários.",
        gettingstart: "HOT | Guia para Iniciantes",
        officialstart: "Atendimento Oficial da BIPPAX",
        oneminutebuy: "Transação de Moeda",
        oneminutebuytips: "Use um ativo digital para trocar diretamente por outro",
        baseknow: "Transação de Contrato",
        baseknowtips: "T+0 negociação de bens virtuais em duas vias como contrato de troca",
        baseexchange: "Contrato de Opção",
        baseexchangetips: "É um derivativo de ativo digital",
        usersocial: "Troca Rápida",
        usersocialtips: "Troque ativos digitais rapidamente",
        mainboard: "Plataforma Principal",
        preview: "Anterior",
        nextpage: "Próxima",
        downloadwhite: "Baixar White Paper"
    },
    nav: {
        ptjy: 'Negociação de Plataforma',
        ptaq: 'Segurança da Plataforma',
        ptsl: 'Força da Plataforma',
        xwzx: 'Centro de Notícias',
        fabu: 'Publicidade',
    },
    progress: {
        already: "Já minerado",
        total: "Quantidade total de minério extraível: 6 bilhões BHB"
    },
    service: {
        USDT: 'USDT',
        BTC: 'BTC',
        ETH: 'ETH',
        CUSTOM: 'Favoritos',
        COIN: 'Moeda',
        symbol: 'Par de Transação',
        favor: 'Favorito',
        NewPrice: "Último",
        ExchangeNum: 'Quantidade',
        Change: 'Variação',
        OpenPrice: 'Preço de Abertura',
        PriceTrend: 'Tendência de Preço',
        Operate: 'Operação',
        Exchange: 'Trocar',
        trading: "Negociação",
        high: "Mais Alto",
        low: "Mais Baixo"
    },
    swapAssets: {
        Br1: 'Retorno de Compra',
        Br2: 'Compra por assinatura',
        Br3: 'Transferir para conta de contrato',
        Br4: 'Transferir da conta de contrato',
        Br5: 'Lucro e perda de contratos perpétuos',
        Br6: 'Fim',
        Br7: 'Conta de contrato (padrão em U)',
        Br8: 'Saldo da carteira',
        Br9: 'Preço atual',
        Br10: 'Abrir mais',
        Br11: 'Abrir menos',
        Br12: 'Ocultar outros contratos',
        Br13: 'Fechar posição com um clique',
        Br14: 'Cancelar todos os pedidos',
        Br15: 'Correção de saldo de contrato perpétuo',
    },
    exchange: {
        wholehog: 'Tudo',
        coin: 'Moeda',
        symbol: 'Par de Transação',
        lastprice: 'Último',
        daychange: 'Variação',
        market: 'Mercados',
        favorite: 'Marcado',
        do_favorite: 'Adicionado',
        cancel_favorite: 'Removido',
        type: "Tipo",
        dealamount: "Quantidade Realizada",
        high: 'Alta',
        low: 'Baixa',
        vol: 'Vol. 24H',
        buy: 'Comprar',
        sell: 'Vender',
        limited_price: 'Preço Limitado',
        market_price: 'Preço de Mercado',
        fees_rate: 'Taxa',
        balance: 'Saldos',
        or: 'ou',
        starttrade: 'Negocie Agora!',
        canuse: 'Disponível',
        recharge: 'Depositar',
        buyprice: 'Preço de Compra',
        buynum: 'Compra',
        amount: 'Valor',
        buyin: 'Comprar',
        disablebuyin: "Compra de Mercado Desativada",
        buytip: 'Compra Ótima',
        sellprice: 'Preço de Venda',
        sellnum: 'Venda',
        sellout: 'Vender',
        disablesellout: "Venda de Mercado Desativada",
        selltip: 'Venda Ótima',
        curdelegation: 'Delegar',
        hisdelegation: 'Histórico de Delegação',
        realtransaction: 'Negociações do Mercado',
        num: 'Quantidade',
        price: 'Preço',
        direction: 'Direção',
        time: 'Tempo',
        stall: 'Nível',
        total: 'Total',
        traded: 'Concluído',
        action: 'Ação',
        undo: 'Desfazer',
        delegationnum: 'Quantidade Delegada',
        done: 'Concluído',
        status: 'Status',
        finished: 'Finalizado',
        canceled: 'Cancelado',
        parted: "Parcial",
        tip: 'Dica',
        buyamounttip: 'Insira a quantidade de compra',
        buyamounttipwarning: 'A quantidade de compra não deve exceder',
        success: 'Enviado com sucesso!',
        pricetip: 'Insira o preço de compra',
        pricetipwarning: 'O preço de compra não deve exceder',
        sellamounttip: 'Insira a quantidade de venda',
        sellamounttipwarning: 'A quantidade de venda não deve exceder',
        sellpricetip: 'Insira o preço de venda',
        sellpricetipwarning: 'O preço de venda não deve exceder',
        undotip: 'Confirmar desfazer?',
        cancelsuccess: "Pedido cancelado com sucesso",
        marketprice: 'Preço de Mercado',
        expand: {
            time: 'Tempo',
            price: 'Preço',
            amount: 'Quantidade',
            fee: 'Taxa',
        },
        realtime: 'Tempo real',
        kline: "KLine",
        depth: "Profundidade",
        publishstate0: "Está prestes a começar. Por favor, aguarde...",
        publishstate1: "Está prestes a terminar. Por favor, aguarde...",
        publishstate2: "Consolidação de pedidos, por favor aguarde...",
        publishstate3: "Consolidação concluída, negocie à vontade...",
        publishdetail: "Mais detalhes",
        publishprice: "Preço",
        publishamount: "Quantidade",
        publishcounttxt0: "Começa em",
        publishcounttxt1: "Termina em",
        publishcounttxt2: "Negociação livre em",
        publishcounttxt3: "Atividade encerrada!",
        dateTimeDay: "D",
        dateTimeHour: "H",
        dateTimeMinutes: "M",
        dateTimeSeconds: "S",
        moredetail: "Ver mais"
    },
    swap: {
        Sw1: 'Aumentar margem',
        Sw2: 'Reduzir margem',
        Sw3: 'Aumentar',
        Sw4: 'Reduzir',
        Sw5: 'Margem',
        Sw6: 'Máximo permitido',
        Sw7: 'O preço subsequente de liquidação forçada é',
        Sw8: 'A relação de alavancagem após é',
        Sw10: 'Aumentar a margem do contrato',
        Sw11: 'Reduzir a margem do contrato',
        Sw12: 'Texto Descritivo',
        Spsl1: 'Tempo de acionamento real',
        Spsl2: 'Número real de acionamentos',
        Spsl3: 'Direção de acionamento real',
        Spsl4: 'Preço de acionamento real',
        contract: "Contrato",
        swapindex: "Perpétuo",
        coin: 'Moeda',
        symbol: 'Par de Moeda',
        volume: "Volume",
        lastprice: 'Último',
        daychange: 'Variação',
        market: 'Mercados',
        favorite: 'Favorito',
        do_favorite: 'Adicionado',
        cancel_favorite: 'Removido',
        type: "Tipo",
        dealamount: "Quantidade Realizada",
        high: 'Alta',
        low: 'Baixa',
        vol: 'Volume 24H',
        buy: 'Comprar',
        sell: 'Vender',
        limited_price: 'Preço Limitado',
        market_price: 'Preço de Mercado',
        spot_price: 'Preço de Acionamento',
        fees_rate: 'Taxa',
        balance: 'Saldos',
        or: 'ou',
        starttrade: 'Negocie Agora!',
        canuse: 'Disponível',
        recharge: 'Depositar',
        buyprice: 'Preço de Compra',
        buynum: 'Quantidade de Compra',
        amount: 'Valor',
        buyin: 'Comprar',
        disablebuyin: "Compra de Mercado Desativada",
        buytip: 'Compra Ótima',
        sellprice: 'Preço de Venda',
        sellnum: 'Quantidade de Venda',
        sellout: 'Vender',
        disablesellout: "Venda de Mercado Desativada",
        selltip: 'Venda Ótima',
        curdelegation: 'Delegar',
        hisdelegation: 'Histórico de Delegação',
        realtransaction: 'Negociações do Mercado',
        num: 'Quantidade',
        price: 'Preço',
        direction: 'Direção',
        time: 'Tempo',
        stall: 'Nível',
        total: 'Total',
        traded: 'Concluído',
        action: 'Ação',
        undo: 'Desfazer',
        delegationnum: 'Quantidade Delegada',
        done: 'Concluído',
        status: 'Status',
        finished: 'Finalizado',
        canceled: 'Cancelado',
        parted: "Parcial",
        tip: 'Dica',
        buyamounttip: 'Insira a quantidade de compra',
        buyamounttipwarning: 'A quantidade de compra não deve exceder',
        success: 'Enviado com sucesso!',
        pricetip: 'Insira o preço de compra',
        pricetipwarning: 'O preço de compra não deve exceder',
        sellamounttip: 'Insira a quantidade de venda',
        sellamounttipwarning: 'A quantidade de venda não deve exceder',
        sellpricetip: 'Insira o preço de venda',
        sellpricetipwarning: 'O preço de venda não deve exceder',
        undotip: 'Confirmar desfazer?',
        cancelsuccess: "Pedido cancelado com sucesso",
        marketprice: 'Preço de Mercado',
        expand: {
            time: 'Tempo',
            price: 'Preço',
            amount: 'Quantidade',
            fee: 'Taxa',
        },
        realtime: 'Tempo Real',
        kline: "KLine",
        depth: "Profundidade",
        open: "Abrir",
        close: "Fechar",
        latestdeal: "Última negociação",
        myswapaccount: "Minha Conta de Swap",
        accountmode: "Padrão",
        accountmargin: "Alavancagem",
        accountquanyi: "Equidade",
        profitandloss: "Lucro/Perda Não Realizado",
        principalAmount: "Margem Disponível",
        positionAmount: "Margem Usada",
        frozenAmount: "Margem Congelada",
        principalRate: "Taxa de Margem",
        zijinhuazhuan: "Transferir",
        up: "Compra",
        down: "Venda",
        canup: "Máx. Compra",
        candown: "Máx. Venda",
        cancloseup: "Fechar Venda Máx.",
        canclosedown: "Fechar Compra Máx.",
        openup: "Abrir Longo",
        opendown: "Abrir Curto",
        closeup: "Fechar Curto",
        closedown: "Fechar Longo",
        currentposition: "Posições Abertas",
        assetsdetail: "Transações",
        marginMode1: "Isolada",
        marginMode2: "Cruzada",
        modifyMarginModeTitle: "Alterar Modo de Margem",
        modifyLeverage: "Ajustar Alavancagem",
        moredetail: "Ver Mais",
        shareNumber: "Contagem",
        entrustprice: "Preço",
        triggleprice: "Acionamento",
        openvolume: "Volume Longo",
        closevolume: "Volume Curto",
        triggleplaceholder: "O preço padrão é de mercado",
        marketpriceplaceholder: "Será negociado pelo melhor preço",
        levmaxtip: "A alavancagem não deve exceder o máximo",
        levmintip: "A alavancagem não deve ser menor que o mínimo",
        marginModeSuccessTip: "Modificação bem-sucedida.",
        noenoughbalance: "Saldo insuficiente",
        pleaseinputopenvolume: "O volume deve ser superior a 0",
        pleaseinputcorrectopenvolume: "Insira o volume correto",
        pleaseinputrightentrustprice: "Insira o preço correto",
        noenoughposition: "Posição insuficiente",
        pleaseinputclosevolume: "O volume deve ser superior a 0",
        pleaseinputcorrectclosevolume: "Insira o volume correto",
        pos_Pl: "Lucro/Perda",
        pos_Ratio: "Taxa de Lucro/Perda",
        pos_pos: "Posição",
        pos_canClose: "Posição Disponível",
        pos_openPrice: "Preço de Abertura",
        pos_leverage: "Alavancagem",
        pos_margin: "Margem Atual",
        pos_mRatio: "Taxa de Margem",
        pos_cmRatio: "Taxa de Manutenção",
        pos_long: "Longo",
        pos_short: "Curto",
        ent_entrustType: "Abrir/Fechar",
        ent_direction: "Direção",
        ent_type: "Tipo",
        ent_trigglePrice: "Preço de Acionamento",
        ent_entrustPrice: "Preço de Delegação",
        ent_tradedPrice: "Preço Negociado",
        ent_margin: "Margem",
        ent_volume: "Volume",
        ent_status: "Status",
        ent_status1: "Delegando",
        ent_status2: "Cancelado",
        ent_status3: "Falha na Delegação",
        ent_status4: "Negociado",
        ent_statusblast: "Liquidação",
        ent_pl: "Lucro/Perda",
        ent_fee: "Taxa",
        triggerpriceshouldbigger: "O preço de acionamento deve ser superior a 0",
    },

    ctc: {
        title: "Venda com um clique ● Garantia da plataforma ● Segurança",
        desc: "Os ativos criptográficos são gerenciados pela BIPPAX, e o receptor fornece serviços de troca para a negociação.",
        buyin: "Comprar",
        sell: "Vender",
        buyprice: "Preço de Compra",
        sellprice: "Preço de Venda",
        buynum: "Quantidade de Compra",
        sellnum: "Quantidade de Venda",
        payamount: "Pagamento",
        getamount: "Pagamento",
        avabalance: "Disponível",
        time: "Data da Negociação",
        tip: "Aviso",
        notice: "Aviso",
        notice1: "1. A área de negociação de moeda fiduciária é uma transação de ativos entre usuários e receptores. Os fundos não são transferidos para uma plataforma, e a plataforma não aceita recarga/remessa em RMB;",
        notice2: "2. Os receptores das transações de moeda fiduciária passaram pela certificação de nome real, oferecendo margens de transação, e os tokens são hospedados pela plataforma, então você pode ter a certeza de que podem ser convertidos;",
        notice3: "3. O horário de serviço do receptor é de 09:00-21:00 por dia. A aceitação é concluída dentro de 30 minutos após a aceitação do pedido, e a transação não concluída dentro de duas horas será cancelada;",
        notice4: "4. Para apoiar cartões bancários na área de negociação de moeda fiduciária, é necessário transferir fundos usando uma conta que você tenha autenticado pelo seu nome real;",
        notice5: "5. Para garantir a segurança dos fundos da transação, a negociação de moeda fiduciária exige que os usuários passem pela autenticação de nome real;",
        payType: "Conta de Pagamento",
        receiveType: "Conta de Recebimento",
        moneyTips: "O preço acima é apenas para referência. Por favor, consulte o valor real de liquidação após o seguinte pedido.",
        verifyset: "Nome Real/Senha de Ativos",
        payset: "Configurações de Pagamento",
        trade: "Troca",
        input50tips: "Por favor, insira um número entre 50 e 50.000",
        bank: "Cartão Bancário",
        alipay: "Alipay",
        wechatpay: "Wechat",
        payaccountset: "Configurações de Conta de Pagamento",
        useselfaccount: "Por favor, use uma conta autenticada pelo seu nome real.",
        orderSn: "Número do Pedido",
        tradetime: "Data da Troca",
        direction: "Direção",
        amount: "Quantidade(USDT)",
        money: "Total(CNY)",
        price: "Preço(CNY)",
        status: "Status",
        operate: "Operar",
        moredetail: "Mais detalhes"
    },
    cexchange: {
        title: "Atividade BZB",
        desc: "Moeda BZB ● Um clique ● Lucro todo dia",
        quantity: "Quantidade da Compra da Atividade",
        inputtips1: "Número personalizado",
        choosecurrency: "Escolha uma moeda",
        all: "Todos",
        totalpay: "Quantidade de Moeda Paga",
        restricted: "Total restrito hoje",
        currentprice: "Preço atual",
        nextprice: "Preço da próxima emissão",
        confirmpay: "Confirmar pagamento",
        assets: "Ativos:",
        loginFirst: "Por favor, faça login",
        success: "Parabéns, Troca realizada com sucesso!",
        tip: "Dicas",
        confirm: "Confirmar dicas",
        confirmmsg: "Tem certeza de que deseja trocar BZB?",
        ok: "OK",
        cancel: "Cancelar"
    },
    subscribe: {
        Su1: 'Página de Detalhes',
        Su2: 'Assinatura',
        Su3: 'Assinatura de nova moeda',
        Su4: 'A ser iniciado',
        Su5: 'Em progresso',
        Su6: 'A ser anunciado',
        Su7: 'Distância',
        Su8: 'Iniciar',
        Su9: 'Preço de Emissão',
        Su10: 'Taxa esperada de lucro e perda',
        Su11: 'Hora de Início',
        Su12: 'Hora de Publicação',
        Su13: 'Detalhes',
        Su14: 'Assinatura',
        Su15: 'Registro de Assinatura',
        Su16: 'Nome da moeda',
        Su17: 'Preço de emissão',
        Su18: 'Preço de emissão',
        Su19: 'Número de ofertas vencedoras',
        Su20: 'Montante do reembolso',
        Su21: 'Hora',
        Su22: 'Status',
        Su23: 'Hora',
        Su24: 'Quantia da Assinatura',
        Su25: 'Moeda de Assinatura',
        Su26: 'Preço de emissão',
        Su27: 'Lucro e perda esperados',
        Su28: 'Limite de Assinatura',
        Su29: 'Hora de início da assinatura',
        Su30: 'Hora de fim da assinatura',
        Su31: 'Hora de publicação dos resultados',
        Su32: 'Hora de lançamento esperada',
        Su33: 'Quantia da Assinatura',
        Su34: 'Moeda',
        Su35: 'Quantia da Assinatura',
        Su36: 'Hora da Assinatura',
        Su37: 'Status',
        Su38: 'A ser anunciado',
        Su39: 'Publicado',
        Su40: 'Informações do projeto',
        Su41: 'Saldo disponível',
        Su42: 'Aplicar imediatamente',
        Su43: 'Todos',
        Su44: 'Senha de pagamento',
    },
    option: {
        minute: 'min',
        enter: 'Por favor, insira',
        title: "Contrato de Opção",
        buyupreward: "Recompensa do Pool de Compra",
        buydownreward: "Recompensa do Pool de Venda",
        quantity: "Quantia Apostada",
        myamount: "Minha Quantia Apostada",
        buyup: "Altista",
        buydown: "Bajista",
        history: "Histórico",
        seriers: "Nº",
        period: "",
        currentoption: "Intervalo de Tempo",
        openprice: "Preço de Abertura",
        currentprice: "Preço Atual",
        openprice1: "Preço de Abertura",
        closeprice: "Preço de Fechamento",
        opentime: "Hora de Abertura",
        closetime: "Hora de Fechamento",
        progress: "Progresso",
        loginFirst: "Por favor, faça login primeiro!",
        selectAmount: "Por favor, selecione o seu valor",
        balancenotenough: "Saldo insuficiente!",
        betsuccess: "Parabéns! Aposta realizada com sucesso!",
        noopening: "Sem abertura no momento!",
        col_createTime: "Hora de Criação",
        col_direction: "Direção",
        col_result: "Resultado",
        col_optionNo: "Nº",
        col_betAmount: "Quantia Apostada",
        col_rewardAmount: "Quantia de Recompensa",
        col_fee: "Taxa de Abertura",
        col_winfee: "Taxa de Recompensa",
        win: "Vencer",
        lose: "Perder",
        wait: "Abrindo",
        avaliablebalance: "Saldo Disponível",
        login: "Por favor, faça login",
        kline: "Cotações em Tempo Real",
        or1: 'Preço atual',
        or2: 'Tempo de Aposta',
        or3: 'Quantia de Aposta',
        or4: 'Moeda de Aposta',
        or5: 'Quantia adicional',
        or6: 'O preço atual é o preço de execução',
        or7: 'Histórico de Negociação',
        or8: 'Odds',
        or9: 'Bônus',
        or10: 'Registro de Negociação',
        or11: 'Por favor, selecione 4 quantias de aposta USDT comuns',
    },
    otc: {
        ad: 'Publicidade',
        buyin: 'Comprar',
        sellout: 'Vender',
        merchant: 'Mercante',
        applymerchant: 'Aplicar para Mercante',
        volume: 'Volume',
        paymethod: 'Método de Pagamento',
        amount: 'Quantia',
        price_coin: 'Preço/Moeda',
        operate: 'Ação',
        validate: 'Por favor, verifique primeiro',
        sell: 'vender',
        buy: 'comprar',
        transaction: 'Transações Comerciais',
        buttontxt: "Torne-se um Mercante",
        title: "Troca OTC",
        desc: "Venda conveniente, segura e rápida de moeda digital",
        title1: "Ajuste Dinâmico",
        desc1: "Flutuação em tempo real de acordo com o preço de mercado",
        title2: "Sem Taxa",
        desc2: "O que você vê é o que você recebe. Além do preço de venda, não há taxa de serviço da plataforma",
        title3: "Transação Imediata",
        desc3: "Introdução de serviços da plataforma para mercantes, correspondência inteligente, fechamento de pedidos, sem necessidade de aguardar por correspondência",
        title4: "Garantia da Plataforma",
        desc4: "Negócio certificado pela plataforma, segurança garantida, suporte 24 horas ao cliente para transações",
        myad: {
            title: 'Meu Anúncio',
            post: 'Postar um Anúncio',
            alert: '【Dica】: Quando a quantia mínima de compras publicitárias mais a taxa for maior do que o número restante de anúncios, o anúncio será automaticamente retirado.',
            no: 'não',
            type: 'tipo',
            sell: 'vender',
            buy: 'comprar',
            limit: 'limite',
            remain: 'quantia restante',
            coin: 'moeda',
            created: 'data de criação',
            operate: 'ação',
            errmsg: 'Pode ser editado e modificado após o anúncio ser retirado',
            update: 'editar',
            shelf: 'colocar à venda',
            dropoff: 'remover',
            delete: 'deletar',
        },
        myorder: 'Meu Pedido',
        chatline: {
            status_1: 'O comprador não pagou, aguarde o pagamento do comprador!',
            status_2: 'O comprador pagou, aguarde o vendedor liberar!',
            status_3: 'Pedido completado com sucesso!',
            status_4: 'Pedido está sendo apelado!',
            status_5: 'Pedido cancelado!',
            loadmore: 'Carregar mais',
            warning: 'Alertas de antifraude: Recentemente, fraudadores têm usado informações de transferência bancária e documentos falsos para fraudes, então por favor, verifique sempre o número da sua conta bancária. Garanta a segurança dos fundos e evite o risco de seu cartão bancário ser congelado!',
            contenttip: 'Por favor, insira o conteúdo do chat, pressione Enter para enviar',
            contentmsg: 'A mensagem não pode ser vazia',
        },
        chat: {
            seller: 'Vendedor',
            buyer: 'Comprador',
            exchangeamount: 'Quantia de Troca',
            operatetip: 'Dica de operação',
            operatetip_1: 'Por favor, complete o pagamento conforme a conta fornecida pela outra parte dentro do prazo e clique nesta página.',
            finishpayment: 'Pagamento completado',
            operatetip_1_1: 'Por favor, adicione o número de referência de pagamento na transferência',
            operatetip_1_2: 'Após receber o pagamento, o vendedor confirmará o pagamento no site. O sistema enviará automaticamente os ativos digitais adquiridos para sua conta. Por favor, note que',
            note: 'Nota',
            notetip: 'Por favor, não use outros softwares de chat para se comunicar, e não aceite documentos, anexos de e-mails, etc. enviados pela outra parte. Toda a comunicação deve ser feita na janela de chat desta página.',
            operatetip_2_1: 'Os ativos digitais que você vendeu foram enviados à plataforma para custódia e congelamento. Você confirmou o pagamento, clique',
            operatetip_2_2: 'Por favor, não acredite em nenhum motivo para liberar as moedas, confirme o recebimento do pagamento e libere os ativos digitais para evitar perdas!',
            operatetip_2_3: 'Após receber a mensagem do banco, por favor, faça login no banco online ou mobile para confirmar se o pagamento foi contabilizado, para evitar o falso lançamento dos ativos digitais devido ao recebimento de mensagens fraudulentas!',
            confirmrelease: 'Confirmar liberação',
            paydigital: 'Pagar ativos digitais',
            orderstatus: 'Status do pedido',
            orderstatus_1: 'pagamento completado',
            orderstatus_2: 'Apelação do pedido',
            orderstatus_3: 'Confirmar liberação',
            orderstatus_4: 'Cancelar transação',
            orderstatus_5: 'Apelação do pedido',
            order: 'Pedido',
            and: 'e',
            transition: 'troca',
            transprice: 'Preço de negociação',
            transnum: 'Número de negociação',
            transmoney: 'Quantia de negociação',
            tip1: 'O usuário ainda não adicionou o número do cartão bancário',
            tip2: 'O usuário ainda não adicionou a conta Alipay',
            tip3: 'O usuário ainda não adicionou a conta WeChat',
            zfb: 'Alipay',
            wx: 'WeChat',
            qrcode: 'QR Code',
            msg1: 'Tem certeza de que pagou?',
            msg2: 'Pagamentos não são reembolsáveis! Tem certeza de que deseja cancelar seu pedido?',
            msg3: '【Repetir】: Pagamentos não são reembolsáveis! Tem certeza de que deseja cancelar seu pedido?',
            msg4: 'Pago, não recebido',
            msg5: 'Já pago, não recebido',
            tip: 'Dica',
            comptype: 'Tipo de queixa',
            compremark: 'Comentário da queixa',
            willcomp: 'Quero reclamar',
            msg6: 'Você confirma a liberação da moeda?',
            result_1: 'aguardando pagamento',
            result_2: 'Aguardando liberação',
            result_3: 'Concluído',
            result_4: 'Apelando',
            result_5: 'Cancelado',
            msg7: 'Senha do fundo',
            msg7tip: 'por favor, insira a senha do fundo',
        },
        checkuser: {
            emaildone: 'E-mail verificado',
            emailundo: 'E-mail não verificado',
            teldone: 'Telefone verificado',
            telundo: 'Telefone não verificado',
            idcarddone: 'ID verificada',
            idcardundo: 'ID não verificada',
            language: 'idioma',
            languagetext: 'Chinês',
            registtime: 'Hora de registro',
            label: 'Tipo de conta',
            usertype1: 'Mercante verificado',
            usertype2: 'Comprador verificado',
            usertype3: 'Vendedor não verificado',
        },
        tradecenter: {
            postad: 'Postar um anúncio',
            exchange: 'Transação GCC',
            buyin: 'Quero comprar',
            sellout: 'Quero vender',
        },
        tradeinfo: {
            emaildone: 'Email verificado',
            emailundo: 'Email não verificado',
            teldone: 'Telefone verificado',
            telundo: 'Telefone não verificado',
            idcarddone: 'ID verificada',
            idcardundo: 'ID não verificada',
            exchangetimes: 'Número de transações',
            price: 'Preço',
            num: 'Quantia',
            paymethod: 'Método de pagamento',
            exchangelimitamount: 'Limite de transação',
            location: 'Localização',
            location_text: 'China',
            exchangeperiod: 'Período de transação',
            minute: 'min',
            amounttip: 'Por favor, insira o valor',
            numtip: 'Por favor, insira a quantia',
            remarktip: 'Diga-nos sua solicitação',
            remarktitle: 'Observações do Horizonte',
            exchangetitle: 'Informações da Transação',
            exchange_tip1: 'Após iniciar a solicitação de transação, a moeda digital é bloqueada na custódia e protegida pela plataforma. Se você for o vendedor, após iniciar a solicitação de transação, pode recarregar e aguardar o pagamento do comprador. O comprador paga dentro do prazo. Após receber o pagamento, você deve liberar a moeda digital sob sua custódia.',
            exchange_tip2: 'Leia antes de transacionar《Termos de Serviço da Rede da Plataforma》, perguntas frequentes, guias de transações e outros documentos de ajuda.',
            exchange_tip3: 'Cuidado com os golpistas! Antes de transacionar, verifique a classificação do usuário e tenha mais atenção com contas recém-criadas.',
            exchange_tip4: 'Observe que arredondamentos e flutuações de preço podem afetar a quantia de moeda digital que será transacionada. O valor fixo que você inserir determina o valor final, e a quantia de moeda digital será calculada a partir da taxa de câmbio instantânea no momento em que a solicitação for emitida.',
            exchange_tip5: 'Os serviços de custódia protegem tanto compradores quanto vendedores em transações online. Em caso de disputa, avaliaremos todas as informações fornecidas e liberaremos a moeda digital custodiada para seu legítimo proprietário.',
            warning1: 'Digite até 2 casas decimais',
            warning2: 'Quantia do pedido é',
            warning3: 'Digite até 8 casas decimais',
            warning4: 'A quantidade do pedido é',
            confirmbuyin: 'Confirmar compra',
            confirmsellout: 'Confirmar venda',
            buyin: 'Comprar',
            sellout: 'Vender',
            warning5: 'Por favor, preencha o pedido conforme exigido',
        },
        publishad: {
            createad: 'Criar um anúncio de transação',
            msg1: 'Se você transaciona com frequência, pode criar seu próprio anúncio de negociação. Se você transaciona ocasionalmente, recomendamos que pesquise diretamente.',
            msg2: 'Criar um anúncio de transação é',
            msg3: 'Gratuito',
            msg4: 'Se você deseja editar diretamente os anúncios criados, por favor, verifique',
            tradead: 'Publicidade de Transação',
            myad: 'Meu anúncio',
            iwant: 'Eu quero',
            sellonline: 'vender online',
            buyonline: 'comprar online',
            exchangecoin: 'Trocar moeda',
            country: 'País',
            currency: 'Moeda',
            openfixedprice: 'Abrir preço fixo',
            open: 'Abrir',
            close: 'Fechar',
            usetip: 'Quando ativado, o preço da sua moeda não flutuará com o mercado e o preço não mudará.',
            premiseprice: 'Prêmio',
            premisepricetip: 'Defina o seu prêmio',
            fixedprice: 'Preço fixo',
            fixedpricetip: 'Por favor, insira seu preço de troca',
            marketprice: 'Preço de referência de mercado',
            marketpricetip: 'O prêmio refere-se à porcentagem superior ao preço atual de mercado',
            exchangeprice: 'Preço de troca',
            formual: 'Fórmula de precificação',
            num: 'Quantia',
            num_text1: 'Por favor, insira o que você deseja',
            num_text2: 'quantia',
            exchangeperiod: 'Período de transação',
            exchangeperiod_text1: 'Por favor, insira o prazo de sua transação',
            minute: 'min',
            tip1: 'Quanto tempo o comprador pode aceitar transações, por favor, insira um número inteiro',
            tip2: '【Dica】Pode ser vinculado ao centro pessoal / Adicionar método de pagamento',
            tip3: 'Por favor, insira seu valor mínimo de transação',
            tip4: 'Por favor, insira seu valor máximo de transação',
            tip5: 'Você pode preencher seus requisitos especiais nas informações de observação, como: requisitos do comprador, horário online, etc.',
            paymode: 'Método de pagamento',
            minlimit: 'Valor mínimo de transação',
            maxlimit: 'Valor máximo de transação',
            remark: 'Observações',
            openautoreply: 'Abrir resposta automática',
            msg5: 'Quando ativado, quando o usuário iniciar uma transação para você através deste anúncio, o sistema enviará automaticamente a frase de resposta automática que você selecionou para a outra parte.',
            autoreply: 'Resposta Automática',
            autoreplytip: 'Após receber o pedido, a informação é retornada automaticamente ao comprador, por exemplo: método de pagamento, número da conta de coleta, etc.',
            fundpwd: 'Senha de fundos',
            fundpwdtip: 'Por favor, insira sua senha de fundos',
            submit: 'Submeter',
            warning1: 'Por favor, insira o número correto',
            warning2: 'O valor excedente é de 0-20',
            warning3: 'Por favor, insira o seu valor máximo de transação!',
            warning4: 'Por favor, insira um número inteiro',
            warning5: 'O valor máximo da transação deve ser maior que o valor mínimo da transação!',
            warning6: 'O valor máximo da transação não pode exceder o valor total da sua venda',
            warning7: 'Por favor, insira o seu valor mínimo de transação!',
            warning8: 'O valor mínimo da transação deve ser maior ou igual a 100!',
            warning9: 'O valor mínimo da transação deve ser menor que o valor máximo da transação',
            sellout: 'Vender',
            buyin: 'Comprar',
            inputtip1: 'Por favor, insira a moeda',
            inputtip2: 'Por favor, insira a opção correta',
            inputtip3: 'O valor excedente é de 0-20 e não pode ser 0',
            inputtip4: 'Por favor, insira o preço fixo correto',
            inputtip5: 'Por favor, insira o número correto, e o número máximo de transações não deve exceder 100',
            inputtip6: 'Por favor, insira o prazo correto da transação',
            inputtip7: 'Por favor, selecione o método de transação',
            inputtip8: 'Por favor, insira a senha dos fundos',
            zfb: 'Alipay',
            wx: 'WeChat',
            unionpay: 'UnionPay',
            submit_failure: 'Falha!',
            submittip1: 'Por favor, prossiga com uma série de certificações como nome verdadeiro',
            submittip2: 'Por favor, faça uma série de certificações como telefone',
            submittip3: 'Por favor, prossiga com uma série de certificações como senha de fundos',
            submittip4: 'Por favor, vincule pelo menos um método de pagamento',
        },
        index: {
            title: 'Boa recomendação de publicidade',
            exchangetimes: 'Número de transações',
            exchangeprice: 'Preço da transação',
            exchangelimit: 'Limite de transação',
            paymode: 'Método de pagamento',
            buy: 'comprar',
            sell: 'vender',
            viewmore: 'Mais',
            bot1: 'Seguro e confiável',
            bot1_tip: 'Mais de 10 anos de experiência na equipe de controle de risco financeiro\nSistema de política de segurança personalizável',
            bot2: 'Rápido e fácil',
            bot2_tip: 'Modo de transação peer-to-peer sem taxas de usuário\nDiversos canais de troca de dinheiro',
            bot3: 'Moeda total',
            bot3_tip: 'Seleção de moedas de ativos digitais populares\nExperiência de negociação multi-ativos',
            ibuy: 'Quero comprar',
            isell: 'Quero vender',
        }
    },
    activity: {
        all: "Todos",
        prepare: "Em breve",
        ongoing: "Em andamento",
        distributing: "Distribuindo",
        completed: "Concluído",
        progress: "Progresso",
        totalsupply: "Oferta Total",
        starttime: "Data de Início",
        endtime: "Data de Término",
        viewdetail: "Detalhe",
        attend: "Participar",
        tokendistribute: "Distribuição de Tokens",
        baseinfo: "Informações da Atividade",
        status: "Status",
        activitytype: "Tipo de Atividade",
        activitytype0: "Desconhecido",
        activitytype1: "Listagem (FOF)",
        activitytype2: "Listagem (AVA)",
        activitytype3: "Divisão de Titulares",
        activitytype4: "Compra Gratuita",
        activitytype5: "Compra de Mineração",
        activitytype6: "Bloqueado",
        ruledetail: "Sobre a Regra",
        publishprice: "Preço de Publicação",
        activitycoin: "Símbolo da Moeda da Atividade",
        accpetcoin: "Símbolo da Moeda Aceita",
        holdcoin: "Símbolo da Moeda de Bloqueio",
        limittimes: "Limite Pessoal de Participações",
        limitamount: "Limite Pessoal de Quantia",
        unlimited: "Ilimitado",
        alreadyamount: "Quantia Já Vendida",
        leftamount: "Quantia Restante",
        attention: "Atenção",
        attentiontxt1: "1、Os ativos serão congelados após a inscrição para participar de atividades do tipo [partição de armazém] e [inscrição gratuita] até que o descongelamento seja concluído.",
        attentiontxt2: "2、Os usuários não poderão retirar sua inscrição após participarem de atividades do tipo 'Divisão de Titulares' e 'Compra Gratuita'.",
        attentiontxt3: "3、Se a atividade for cancelada devido à parte do projeto ou outros fatores de força maior, os ativos congelados serão devolvidos à rota original.",
        attentiontxt4: "* O direito de interpretação final desta atividade pertence à propriedade oficial da BIPPAX.",
        inputamount: "Inserir Quantia",
        inputholdamount: "Inserir Quantia de Bloqueio",
        mybalance: "Saldo Disponível",
        holdtips: "[Divisão de Titulares] requer bloqueio até o final da atividade.",
        pleaseinputamount: "Por favor, insira a quantia!",
        pleaseinputholdamount: "Por favor, insira a quantia de bloqueio!",
        commitfailed: "Falha ao Submeter!",
        minlimitamountfailed: "A quantia de troca não pode ser menor que o valor mínimo de troca!",
        maxlimitamountfailed: "A quantia de troca não pode ser maior que o valor máximo de compra!",
        limittimesfailed: "Você participou mais vezes do que o número máximo de compras individuais!",
        balancenotenough: "Saldo insuficiente!",
        headertitledesc: "Abrir Laboratórios para Cooperação Vencedora entre Investidores, Projetos e Exchanges",
        currentdivided: "Minha posição atual receberá",
        leveloneCount: "Número de Limite do Nível Um",
        submit: "Submeter",
        tipsmobile: "Por favor, use a versão PC do site (www.BIPPAX.com)",
        tipsmobile1: "Você pode acessar a versão PC para participar desta atividade.",
        intvalue: "Por favor, insira um valor inteiro",
        inputminingamount: "Inserir Quantia de Compra",
        moreactivity: "Mais Atividades",
        releaseType: "Tipo de Liberação",
        releaseType0: "Liberação Igual",
        releaseType1: "Liberação Isométrica",
        lock: "Bloquear",
        releaseDetail: "Detalhes da Liberação",
        lockday: " Dias",
        lockweek: " Semanas",
        lockmonth: " Meses",
        lockyear: " Anos",
        releasePercent: "Percentual de Liberação",
        lockFee: "Taxa de Bloqueio",
        releaseTimes: "Número de Liberações",
        times: "vezes"
    },
    invite: {
        myinvitelink: "Link de Promoção",
        copy: "Copiar",
        copyed: "Copiado",
        mylevelone: "Amigos de Nível Um",
        myleveltwo: "Amigos de Nível Dois",
        mycommission: "Rendimento de Comissão (USDT)",
        extrareward: "Recompensas Adicionais",
        partnerlevel: "Nível de Parceria",
        ruledetail: "Detalhes da Regra",
        ruleprofile1: "[Parceiro de Promoção] tem a maior proporção de retorno de comissão online e o maior período de retorno de comissão (máxima comissão vitalícia). Promotores que se esforçam podem se tornar verdadeiros 'parceiros' da plataforma e aproveitar o dividendo de crescer junto à plataforma de negociação BIPPAX. As regras detalhadas são as seguintes:",
        ruleprofile2: "",
        ruleprofile3: "",
        ruleprofile4: "",
        ruletext1: "1、Para divulgar o conceito de ativos digitais e expandir a base de usuários, a BIPPAX lançou o programa 'Parceiro de Promoção', válido por tempo indeterminado.",
        ruletext2: "2、Convidar amigos pode ser dividido em dois níveis. Se A convida B, então B é amigo de primeiro nível de A. Se B convida C, então C pertence ao primeiro nível de B e ao segundo nível de A.",
        ruletext3: "3、Ao promover o cadastro de amigos, os amigos de primeiro nível dos incentivadores só podem ser de primeiro nível através de links fornecidos pelos incentivadores ou inserindo manualmente o código de convite dos incentivadores.",
        ruletext4: "4、Após o convidado registrar-se com o código de convite do incentivador e completar a certificação de identidade, o incentivo de comissão será ativado.",
        ruletext5: "5、O tempo da comissão é N meses a partir do início da certificação de identidade do convidado. A proporção da comissão varia conforme o grau do convidado.",
        ruletext6: "6、A promoção da comissão de ativos é a taxa de transação das moedas dos amigos de nível inferior, que são as três moedas base do mercado: USDT, BTC e ETH.",
        ruletext7: "7、A proporção e a duração da comissão de promoção estão positivamente correlacionadas com o número de amigos de primeiro nível. Quanto maior o número de promoções, maior a proporção de comissão desfrutada. A proporção do rebate da comissão de promoção é a seguinte:",
        ruletext8: "8、Os TOP10 ou TOP100 serão premiados com incentivos adicionais pela MKWORLDS de tempos em tempos.",
        ruletext9: "9、Se outras atividades entrarem em conflito com as atividades do Parceiro de Promoção, os parceiros devem entender a possibilidade de mudanças temporárias após consulta.",
        ruletext10: "10、Os parceiros de nível L4(Xunfu), L5(Taishou) e L6(Jiedushi) têm direito a bônus de 5%, 10% e 15% sobre o total da comissão anual, respectivamente.",
        ruletext11: "11、O direito de interpretação final desta atividade pertence à BIPPAX.",
        ruleexampletitle: "Por Exemplo:",
        ruleexamplecontent1: "Se o usuário Xiaoyan convidar 100 amigos de primeiro nível, e cada um desses amigos convidar cinco amigos de segundo nível, então Xiaoyan terá 100 amigos de primeiro nível e 500 amigos de segundo nível. Se cada pessoa negociar 3000 yuan por dia, o rendimento mensal de Xiaoyan será aproximadamente (100 * 3000 * 0.001 * 30% + 500 * 3000 * 0.001 * 10%) * 30 = 7200 / mês.",
        ruleexamplecontent2: "Se o usuário Xiaoyan convidar 1000 amigos de primeiro nível, e cada um desses amigos convidar cinco amigos de segundo nível, então Xiaoyan terá 1000 amigos de primeiro nível e 5000 amigos de segundo nível. Se cada pessoa negociar 3000 yuan por dia, o rendimento mensal de Xiaoyan será aproximadamente (1000 * 3000 * 0.001 * 50% + 5000 * 3000 * 0.001 * 20%) * 30 = 135000 / mês.",
        lastupdate: "Última atualização em",
        laststastic: "Última estatística em",
        level: "Nível",
        lv1: "Lizheng",
        lv2: "Xianling",
        lv3: "Zhifu",
        lv4: "Xunfu",
        lv5: "Taishou",
        lv6: "Jiedushi",
        levelonecount: "Número de Nível Um",
        levelonecommission: "Proporção do Retorno de Nível Um / Tempo de Retorno",
        leveltwocommission: "Proporção do Retorno de Nível Dois / Tempo de Retorno",
        partnerdivide: "Dividendo do Parceiro",
        month: "Meses",
        alllife: "Vitalício",
        totalcommissionrank: "Promoção da Comissão Total",
        rank: "Nº",
        userid: "ID do Usuário",
        rankday: "(Dia)",
        rankweek: "(Semana)",
        rankmonth: "(Mês)",
        rankall: "(Todos)",
        promotioncount: "Número de Promoções",
        commissionusdt: "Comissão (USDT)",
        ranktip1: "O número de convites é o número de amigos de primeiro nível. Esta lista classifica as comissões totais de maior para menor.",
        ranktip2: "O número de convites é o número de amigos de primeiro nível. A lista é classificada pelo número de amigos de primeiro nível convidados.",
        thanks: "Obrigado por apoiar a BIPPAX!",
        headertip: "Os dados acima não são atualizados em tempo real. O sistema atualiza as estatísticas a cada 24H.",
        ptools: "Ferramentas de Promoção",
        pt_title: "Cartão de Presente de Criptomoeda",
        pt_desc: "Este é um presente do futuro, para enviar a amigos, parentes, clientes, parceiros.",
        pt_more: "Mais ferramentas estão chegando",
        pt_tips: "Se você tiver uma boa ideia, envie um e-mail para promotion@BIPPAX.com, com uma recompensa após adoção!",
        pt_card_amount: "Valor do Cartão",
        pt_card_deadline: "Prazo",
        pt_card_noend: "Indefinido",
        pt_card_btn: "Obtenha 30 cartões gratuitamente (≈2000 CNY)",
        pt_card_btn_login: "Por favor, faça login primeiro",
        pt_card_rule: "Detalhes da Regra",
        pt_card_summary: "O cartão de presente em moeda digital é uma ferramenta promocional desenvolvida para ajudar os parceiros de promoção a convidar amigos offline. Quando os usuários trocam os cartões de presente, eles se tornam automaticamente amigos offline dos parceiros de promoção.",
        pt_card_rule1: "1. Cartões de presente gratuitos são limitados a 30 cartões por usuário. Se mais cartões de presente forem necessários, o usuário deverá pagar pela personalização, podendo personalizar a quantidade de cartões, LOGO, instruções, etc. Para personalização, envie um e-mail para",
        pt_card_rule2: "2. Cartões de presente gratuitos são limitados a um por usuário. Mesmo que diferentes usuários recebam cartões de presente gratuitos com códigos de troca diferentes, apenas um pode ser trocado. Cartões de presente personalizados não têm essa limitação.",
        pt_card_rule3: "3. Antes que o usuário troque o cartão de presente, se não houver 'incentivador' (ou seja, o código de convite não foi inserido ao registrar a conta), ele será automaticamente associado ao primeiro nível do amigo do emissor do cartão. Se A não inserir um código de convite ao registrar a conta, A não pertence a nenhum amigo de primeiro ou segundo nível, mas quando A for convertido em amigo de primeiro nível de B através do cartão de presente de B, A se tornará automaticamente amigo de primeiro nível de B.",
        pt_card_rule4: "4. Para evitar trapaças, o valor do cartão de presente não é pago em tempo real. Ele será congelado por 180 dias após a coleta e será liberado automaticamente para o saldo da conta do usuário após 180 dias.",
        pt_card_rule5: "5. Ao receber cartões de presente gratuitos, precisamos concluir a certificação de identidade. Ao converter, podemos obtê-los sem concluir a certificação de identidade. Isso facilita os promotores a obter amigos de nível inferior mais rapidamente.",
        pt_card_rule6: "6. O direito de interpretação final dos cartões de presente gratuitos pertence à BIPPAX.PRO.",
        pt_card_day: "Dias",
        pt_card_title_tips: "Concessão gratuita de promoção de 2000 CNY",
        pt_card_receivew_success: "Parabéns! Coleta bem-sucedida dos cartões de presente de promoção do parceiro! Por favor, vá para o Centro Pessoal -> Centro de Cartões e Vouchers.",
        usepromotion: "Usar Materiais Promocionais",
        saveimage: "Salvar Imagem",
        imagetips: "Se você não conseguir baixar as imagens corretamente, baixe usando a ferramenta de captura de tela!",
        pt_invite_title: "Folheto de registro de convite",
        pt_invite_desc: "Torne-se automaticamente amigo subordinado através do registro do código QR, adequado para encaminhar em diversos grupos ou fóruns.",
        colum_text0: "Classificação",
        colum_text1: "Membro",
        colum_text2: "Promoção",
        colum_text3: "Comissão (USDT)",
        colum_text4: "Recompensa Extra",
        context_title: "Código de resgaste exclusivo para Parceiros de Promoção",
        context_title1: "Escaneie para saber mais",
        context_title2: "Meu Código de Convite",
        context_title3: "Imagem de Convite"
    },
    uc: {
        verify: "Finalize o KYC Primeiro",
        login: {
            noaccount: 'Sem conta?',
            register: 'Cadastrar-se',
            login: 'Entrar',
            welcomelogin: 'Bem-vindo',
            usertip: 'Por favor, insira o e-mail',
            pwdtip: 'Digite a senha',
            validatecodeload: 'Carregando código de verificação',
            validatemsg: 'Por favor, finalize a verificação primeiro',
            forget: 'Esqueceu a senha?',
            loginvalidate: 'Por favor, insira o e-mail ou número de telefone',
            pwdvalidate1: 'Por favor, insira a senha',
            pwdvalidate2: 'A senha deve ter pelo menos seis caracteres',
            success: 'Sucesso',
            goregister: "Para se Registrar",
            getlostpwd: "Esqueci a Senha"
        },
        forget: {
            title: "Recuperar Senha",
            hasaccount: 'Já tem uma conta? Entrar',
            login: 'Entrar',
            sendcode: 'Enviar',
            newpwd: 'Digite a nova senha',
            confirmpwd: 'Digite novamente a nova senha',
            save: 'Submeter',
            pwdvalidate1: 'Digite a senha de confirmação',
            pwdvalidate2: 'Senhas não coincidem!',
            resettelpwd: 'Redefinir senha do telefone',
            resetemailpwd: 'Redefinir senha de e-mail',
            newpwdtip: 'Digite a nova senha',
            pwdvalidate3: 'A senha deve ter pelo menos seis caracteres',
            telno: 'Número de telefone',
            mtelno: 'Autenticação por telefone celular',
            memail: 'Autenticação por e-mail',
            smscode: 'Código de verificação por SMS',
            teltip: 'Digite o telefone',
            smscodetip: 'Digite o código de verificação por SMS',
            email: 'E-mail',
            emailcode: 'Código de verificação de e-mail',
            emailtip: 'Digite o e-mail',
            emailcodetip: 'Digite o código de verificação do e-mail',
            resetpwdsuccess: 'Senha redefinida com sucesso',
            smswarn: 'Por favor, verifique o SMS',
        },

        finance: {
            fi1: 'Verstecke kleine Vermögenswerte',
            center: 'Finanzzentrum',
            personalassets: 'Währungsvermögen',
            swapassets: 'Tauschvermögen',
            billdetail: 'Rechnungsdetails',
            charge: 'Einzahlung',
            pickup: 'Abhebung',
            tradetail: 'Handelsabbau',
            paydividends: 'Dividenden auszahlen',
            invitingmining: 'Einladungs-Abbau-Awards',
            money: {
                M1: 'Erhaltene Menge',
                M2: 'Übertragene Menge',
                M3: 'Wechselkurs',
                cointype: 'Münze',
                balance: 'Kontostand',
                frozen: 'Gefrorener Kontostand',
                operate: 'Aktion',
                charge: 'Einzahlung',
                pickup: 'Abhebung',
                onkeytrans: "Übertrag",
                getaddress: 'Adresse abrufen',
                resetsuccess: 'Erfolgreich zurückgesetzt',
                match: 'Übereinstimmung',
                matchtip1: 'Verfügbare Übereinstimmung mit GCX-Betrag',
                matchtip2: 'Geben Sie den Übereinstimmungsbetrag ein',
                matcherr1: 'Bitte geben Sie eine gültige Menge ein!',
                matcherr2: 'Überschreitet die maximale Anzahl der Übereinstimmungen!',
                matchsuccess: 'Übereinstimmung erfolgreich!',
                needreleased: "Vermögenswerte zur Freigabe",
                totalassets: "Geschätzter Gesamtwert der Vermögenswerte:"
            },
            swap: {
                totalassets: "Geschätzter Gesamtwert der Vermögenswerte:",
                swap: "Tausch",
                swaptype: 'SWAP',
                swapassets: "Kontoguthaben",
                avabalance: "Verfügbare Marge",
                usebalance: "Genutzte Marge",
                frozenbalance: "Gefrorene Marge",
                profitandloss: "Nicht realisierte P&L",
                transfor: "Übertragung",
                inputtransferamount: "Übertragungsbetrag",
                all: "Alle",
                currencyaccount: "Spot-Konto",
                swapaccount: "Perpetual Swap-Konto",
                clickchange: "Klicken Sie, um die Richtung zu ändern",
                avaamount: "Verfügbar",
                pleaseselectwallet: "Wählen Sie zuerst ein Überweisungs-Wallet.",
                pleaseinputamount: "Bitte geben Sie den Übertragungsbetrag ein",
                oktransfer: "Jetzt übertragen"
            },
            trade: {
                start_end: 'Start-Ende',
                account_date: 'Zeit für den Kapitalempfang',
                to: 'Zu',
                operatetype: 'Aktionstyp',
                search: 'Suchen',
                charge: 'Einzahlung',
                pickup: 'Abholung',
                transaccount: 'Übertragung',
                exchange: 'Tausch',
                otcbuy: 'OTC-Kauf',
                otcsell: 'OTC-Verkauf',
                activityaward: 'Aktivitäts-Award',
                promotionaward: 'Werbe-Award',
                dividend: 'Dividende',
                vote: 'Abstimmung',
                handrecharge: 'Manuelle Aufladung',
                match: 'Übereinstimmung',
                activitybuy: "Aktivitäts-Kauf",
                ctcbuy: "CTC-Kauf",
                ctcsell: "CTC-Verkauf",
                chargetime: 'Bestellzeit',
                type: 'Typ',
                num: 'Menge',
                status: 'Status',
                finish: 'Abgeschlossen',
                fee: 'Mining-Gebührenrückgabe',
                transactionTime: 'Handelszeit',
                symbol: 'Münzenpaar',
                direction: 'Richtung',
                price: 'Preis',
                entrustment: 'Vollmacht',
                havedeal: 'Ein Geschäft abgeschlossen',
                poundageAmount: 'Servicegebühr',
                exchangeOrderId: "Bestell-ID",
                mineAmount: "Abbau von Währung (BHB)",
                buy: "KAUFEN",
                sell: "VERKAUFEN",
                limit: "LIMIT",
                market: "MARKT",
                clear: "Bedingung löschen",
                turnover: "Umsatz"
            },
            paydividende: {
                money_holding: 'Geldteilung wurde zurückgegeben und angesammelt (ETH):',
                money_hold: 'Dividenden auszahlen (ETH):',
                paydividends: 'Dividenden auszahlen (ETH)',
                account_date: 'Zeit für den Kapitalempfang',
                datehodld: 'Datum der Geldhaltung',
                start_end: 'Start-Ende',
                to: 'Zu',
                operatetype: 'Aktionstyp',
                search: 'Suchen',
                charge: 'Einzahlung',
                pickup: 'Abholung',
                transaccount: 'Übertragung',
                exchange: 'Tausch',
                otcbuy: 'OTC-Kauf',
                otcsell: 'OTC-Verkauf',
                activityaward: 'Aktivitäts-Award',
                promotionaward: 'Werbe-Award',
                dividend: 'Dividende',
                vote: 'Abstimmung',
                handrecharge: 'Manuelle Aufladung',
                match: 'Übereinstimmung',
                chargetime: 'Einzahlungszeit',
                type: 'Typ',
                num: 'Menge',
                status: 'Status',
                finish: 'Abgeschlossen',
                fee: 'Gebühr',
                symbol: 'Münzsymbol',
            },
            record: {
                Please: 'Bitte wählen Sie den Suchzeitraum',
                start_end: 'Start-Ende',
                to: 'Zu',
                operatetype: 'Aktionstyp',
                search: 'Suchen',
                charge: 'Einzahlung',
                pickup: 'Abholung',
                transaccount: 'Übertragung',
                exchange: 'Tausch',
                otcbuy: 'OTC-Kauf',
                otcsell: 'OTC-Verkauf',
                activityaward: 'Aktivitäts-Award',
                promotionaward: 'Werbe-Award',
                dividend: 'Dividende',
                vote: 'Abstimmung',
                handrecharge: 'Manuelle Aufladung',
                match: 'Übereinstimmung',
                chargetime: 'Einzahlungszeit',
                type: 'Typ',
                num: 'Menge',
                status: 'Status',
                finish: 'Abgeschlossen',
                fee: 'Gebühr',
                shouldfee: 'Gebühr fällig',
                revenue: 'Ertrags- und Ausgabentyp',
                re1: 'Eingang',
                re2: 'Ausgang',
                discountfee: 'Abzugsgebühr',
                realfee: 'Servicegebühr',
                symbol: 'Münzsymbol',
                activitybuy: "Aktivitäts-Kauf",
                ctcbuy: "C2C-KAUF",
                ctcsell: "C2C-VERKAUF",
                redout: "RED-AUS",
                redin: "RED-IN",
                quickExchange: "Schnell Tausch",
                currentRate: "Aktueller Wechselkurs",
                from: "Von",
                inputexchangeamount: "Geben Sie den Schnelltauschbetrag ein",
                inputexchangepasswd: "Geben Sie das Austauschpasswort ein",
                chooseTransCoinUnit: "Wählen Sie Trans-Münze",
                inputTransAmount: "Wählen Sie den Übertragungsbetrag",
                predictAmount: "Wird getauscht",
                qamount: "Menge",
                qrate: "Wechselkurs",
                qexamount: "Tauschbetrag",
                withdrawcodein: "Abhebungs-Code-Aufladung",
                withdrawcodeout: "Abhebungs-Code-Abhebung",
                contractfee: "Swap-Gebühr",
                contractprofit: "Swap-Gewinn",
                contractloss: "Swap-Verlust",
                optionfail: "Option fehlgeschlagen",
                optionfee: "Optionsgebühr",
                optionreward: "Optionsbelohnung",
                other: "Sonstiges"
            },
            recharge: {
                recharge: 'Einzahlung',
                symbol: 'Münze',
                address: 'Einzahlungsadresse',
                copy: 'Kopieren',
                qrcode: 'QR-Code',
                qrcodeaddress: 'QR-Code für Einzahlung',
                msg1: 'Überweisen Sie keine Nicht-Währungsvermögen an die oben genannte Adresse, andernfalls können die Vermögenswerte nicht wiederhergestellt werden.',
                msg2: 'Nachdem Sie auf die oben genannte Adresse eingezahlt haben, müssen Sie das gesamte Netzwerknodensystem bestätigen. Nach 2 Netzwerkanerkennungen können Sie nach 6 Netzwerkanerkennungen abheben.',
                msg3: 'Mindestbetrag für die Einzahlung:',
                msgtop: 'Diese Adresse ist nur für die Einzahlung von USDT-Vermögenswerten.',
                msg3_1: ", Einzahlungen unter dem Mindestbetrag werden nicht berücksichtigt.",
                msg4: 'Ihre Einzahlungsadresse wird nicht häufig geändert und Sie können die Einzahlung wiederholen. Wenn eine Änderung erfolgt, benachrichtigen wir Sie gegebenenfalls über eine Website-Ankündigung oder eine E-Mail.',
                msg5: 'Bitte bestätigen Sie unbedingt die Sicherheit Ihres Computers und Browsers, um zu verhindern, dass Informationen manipuliert oder weitergegeben werden.',
                record: 'Aufzeichnung',
                copysuccess: 'Erfolgreich kopiert!',
                copyerr: 'Fehlgeschlagen! Bitte kopieren Sie es manuell',
                time: 'Ankunftszeit',
                amount: 'Betrag',
                gettingaddress: "Einzahlungsadresse wird abgerufen, bitte warten...",
                getaddress: "Einzahlungsadresse abrufen",
                memotips: "Bitte geben Sie dieses Memo bei der Einzahlung ein, andernfalls verlieren Sie Vermögenswerte.",
                withdrawrecharge: "Aufladung durch Code",
                coderechargetip: "Bitte geben Sie den Abhebungs-Code ein",
                rechargesuccess: "Herzlichen Glückwunsch, Einzahlung erfolgreich!",
                rechargeconfirm: "Einzahlungsbestätigung",
                status: "Status"
            },
            withdraw: {
                pickup: 'Abhebung',
                addressmanager: 'Adressverwaltung',
                withdrawbycode: 'Abhebung per Code',
                withdrawcode: 'Abhebungs-Code',
                symbol: 'Münze',
                address: 'Adresse',
                num: 'Menge',
                avabalance: 'Verfügbares Guthaben',
                msg1: 'Die Menge an Münzen ist niedriger als',
                msg2: 'Kommt automatisch im Konto an, andernfalls ist eine manuelle Prüfung erforderlich',
                increase: 'Kredit erhöhen',
                tip1: 'Geben Sie bis zu ',
                tip11: 'Dezimalstellen ein und der Mindestwert ist',
                tip2: 'Der Höchstwert beträgt',
                numtip1: 'Geben Sie die Anzahl der Münzen ein',
                fee: 'Gebühren',
                range: 'Bereich',
                arriamount: 'Ankunftsmenge',
                msg3: 'Der Mindestbetrag beträgt',
                msg4: 'Währung',
                msg5: 'Um die Sicherheit der Mittel zu gewährleisten, werden wir bei einer Änderung Ihrer Kontosicherheitspolitik, Passwortänderung und Verwendung einer neuen Adresse für die Abhebung eine manuelle Prüfung der Münzen durchführen. Bitte haben Sie Geduld und warten Sie auf den Anruf oder die E-Mail des Personals.',
                msg6: 'Bitte bestätigen Sie unbedingt die Sicherheit Ihres Computers und Browsers, um zu verhindern, dass Informationen manipuliert oder weitergegeben werden.',
                record: 'Abhebungsaufzeichnungen',
                symboltip: 'Bitte wählen Sie eine Währung',
                addresstip: 'Bitte füllen Sie die Adresse aus',
                numtip2: 'Bitte geben Sie die korrekte Anzahl der Münzen ein, der Mindestbetrag ist',
                numtip3: 'Die Münzmenge darf nicht niedriger als die Bearbeitungsgebühr sein',
                amounttip: 'Bitte Betrag eingeben',
                feetip1: 'Die Mindestgebühr beträgt',
                feetip2: 'Der Höchstbetrag beträgt',
                time: 'Abhebungszeit',
                status: 'Status',
                status_1: 'Überprüfung',
                status_2: 'Übertragung',
                status_3: 'Fehler',
                status_4: 'Erfolg',
                St5: 'Geschätzte starke Parität',
                St6: 'Gesamtvermögen = Wallet-Guthaben + nicht realisierte Gewinne und Verluste',
                St7: 'Nicht realisierte Gewinne und Verluste = Nicht realisierte Gewinne und Verluste, berechnet mit dem neuesten Preis für alle gehaltenen Verträge',
                St8: 'Wallet-Guthaben = Übertragungen rein - Übertragungen raus - realisierte Gewinne und Verluste',
                St9: 'Abgelehnt',
                remark: 'Bemerkung',
                add: 'Hinzufügen',
                addresslist: 'Adressliste',
                safevalidate: 'Sicherheitsüberprüfung',
                telno: 'Telefon',
                mtelno: 'Mobiltelefon-Authentifizierung',
                memail: 'E-Mail-Authentifizierung',
                smscode: 'Telefon-Verifizierungscode',
                second: 'Sekunde',
                clickget: 'Erhalten',
                email: 'E-Mail',
                emailcode: 'E-Mail-Verifizierungscode',
                save: 'Speichern',
                delete: 'Löschen',
                telerr: 'Falsche Telefonnummer',
                emailerr: 'Falsche E-Mail',
                codeerr: 'Falscher Verifizierungscode',
                remarktip: 'Bemerkung eingeben',
                savemsg1: 'Speichern fehlgeschlagen!',
                savemsg2: 'Erfolgreich gespeichert!',
                operate: 'Betrieb',
                fundpwdtip: 'Bitte geben Sie das Passwort für die Mittel ein',
                click: 'Klicken',
                filtrate: 'kann filtern',
                txid: "TxId",
                generateCode: "Abhebungs-Code generieren",
                withdrawcodelist: "Abhebungs-Code Liste",
                withdrawcodestatus: "Status",
                submit: "Absenden",
                generatecodesuccess: "Abhebungs-Code generiert!",
                wi1: 'Netzwerk',
                wi2: 'Sicherheitsauthentifizierung',
                wi3: 'Eingehende Menge',
                wi4: 'Eingehende Adresse',
                wi5: 'Auszahlungsnetzwerk',
                wi6: 'Gesamtauszahlungsbetrag',
                wi7: 'Netzwerkgebühren',
                wi8: 'Bitte stellen Sie sicher, dass Sie die richtige Auszahlungsadresse eingegeben haben und dass das von Ihnen gewählte Auszahlungsnetzwerk mit der Adresse übereinstimmt.',
                wi9: 'Eine Abhebungsbestellung kann nach der Erstellung nicht storniert werden.',
                wi10: 'Weiter',
                wi11: 'Finanzpasswort',
                wi12: 'Handy-Verifizierungscode',
                wi13: 'Senden',
                wi14: 'E-Mail-Verifizierungscode',
                wi15: 'Senden',
                wi16: 'Einreichen',
            }
        },
        member: {
            usercenter: "Perfil do Usuário",
            securitycenter: "Centro de Segurança",
            securitysetting: "Configurações de Segurança",
            accountsetting: "Configurações da Conta",
            account: "Conta",
            assets: "Finanças",
            exchange: "Câmbio",
            curdelegate: "Delegado Atual",
            hisdelegate: "Delegado Histórico",
            otc: "OTC"
        },
        order: {
            ordercenter: "Centro de Pedidos",
            myorder: "Meus Pedidos",
            myad: "Meu Anúncio"
        },
        regist: {
            Res1: "O nome de usuário deve conter letras maiúsculas, minúsculas e números, e deve conter letras.",
            hasaccount: "Já tem uma conta? Faça login",
            login: "Entrar",
            username: "Nome de usuário",
            country: "País",
            smscode: "Código de verificação por SMS",
            sendcode: "Enviar",
            resendcode: "Reenviar(",
            pwd: "Senha",
            repwd: "Confirmar senha",
            confrimpwd: "Confirmar senha",
            agreement: "Li e concordo",
            userprotocol: "Acordo do Usuário",
            regist: "Cadastrar",
            teltip: "Digite o telefone",
            telerr: "Erro no formato do telefone, tente novamente",
            emailtip: "Digite o e-mail",
            emailerr: "Erro no formato de e-mail, tente novamente",
            confirmpwdtip: "Digite a senha de confirmação",
            confirmpwderr: "As duas senhas não são iguais!",
            telregist: "Cadastro por telefone",
            emailregist: "Cadastro por e-mail",
            usernametip: "Digite o nome de usuário",
            usernamemsg: "O nome de usuário deve ter entre 3 e 15 caracteres",
            countrytip: "Selecione o país",
            smscodetip: "Digite o código de verificação por SMS",
            pwdtip: "Digite a senha de login",
            pwdmsg: "A senha deve ter pelo menos 6 caracteres",
            telno: "Telefone",
            email: "E-mail",
            agreementtip: "Clique para concordar",
            modaltitle: "Por favor, verifique",
            promotion: "Código de convite",
            china: "China",
            singapore: "Singapura",
            korea: "Coreia",
            japan: "Japão",
            thailand: "Tailândia",
            russia: "Rússia",
            uk: "Reino Unido",
            vietnam: "Vietnã",
            india: "Índia",
            italy: "Itália",
            hk: "Hong Kong",
            malaysia: "Malásia",
            taiwan: "Taiwan",
            turkey: "Turquia",
            germany: "Alemanha",
            france: "França",
            spain: "Espanha",
            us: "Estados Unidos"
        },
        safe: {
            Ad1: "Por favor, faça o upload do seu cartão de segurança social, carteira de motorista ou passaporte",
            Ad2: "Faça o upload de um dos arquivos antes de enviar",
            Ad3: "Nome completo",
            Ad4: "Endereço de contato",
            Ad5: "Transmissão ao vivo",
            Ad6: "Minha transmissão ao vivo",
            Ad7: "Falha ao adicionar, no máximo 3 podem ser adicionados",
            size: "O tamanho da imagem carregada não pode exceder 5M",
            safelevel_low: "Nível de Segurança: Baixo",
            safelevel_high: "Nível de Segurança: Alto",
            safelevel_medium: "Nível de Segurança: Médio",
            nickname: "Apelido",
            bind: "Vincular",
            binded: "Vinculado",
            verifypass: "Verificado",
            binding: "Vinculando",
            binderr: "Falha",
            bindretry: "Tentar novamente",
            verified: "Verificado",
            notverified: "Não verificado",
            verifiedtip: "Para proteger a segurança da sua conta, complete a certificação de nome real antes de realizar operações de negociação!",
            realname: "Nome real",
            idcard: "Carteira de identidade",
            upload: "Carregar",
            upload_positive: "Carregar foto do ID (frente)",
            upload_negative: "Carregar foto do ID (verso)",
            upload_hand: "Carregar foto do ID em mãos",
            save: "Salvar",
            reset: "Redefinir",
            email: "E-mail",
            bindemail: "Vincular e-mail",
            loginpwd: "Senha de login",
            emailcode: "Código de verificação por e-mail",
            clickget: "Clique para obter",
            second: "s",
            phone: "Telefone",
            bindphone: "Vincular telefone",
            phonecode: "Código de verificação por telefone",
            logintip: "Use ao fazer login na plataforma",
            edit: "Modificar",
            oldpwd: "Senha antiga",
            newpwd: "Nova senha",
            confirmnewpwd: "Confirmar nova senha",
            fundpwd: "Senha de fundos",
            fundtip: "Quando os fundos da conta mudarem, você precisará verificar a senha de fundos primeiro",
            set: "Configurar",
            confirmpwd: "Confirmar senha",
            oldfundpwd: "Senha antiga de fundos",
            newfundpwd: "Nova senha de fundos",
            newpwdmsg1: "Digite uma nova senha de login com pelo menos 6 caracteres",
            newpwdmsg2: "A nova senha de login está inconsistente",
            pwdmsg1: "Digite uma senha com pelo menos 6 caracteres",
            pwdmsg2: "Senha inconsistente",
            emailtip: "Digite o e-mail",
            codetip: "Digite o código de verificação",
            telnotip: "Digite o número de telefone",
            oldpwdtip: "Digite a senha original",
            realnametip: "Digite seu nome real",
            idcardtip: "Digite o número do ID",
            bindphonetip: "Vincule seu telefone primeiro!",
            resetfundpwd: "Redefinir senha de fundos",
            upload_positivetip: "Carregue a foto da frente do cartão de identidade",
            upload_negativetip: "Carregue a foto do verso do cartão de identidade",
            upload_handtip: "Carregue fotos do ID em mãos",
            save_success: "Sucesso!",
            save_failure: "Falha!",
            imgtip: "Por favor, carregue seu QRCode para receber o pagamento",
            idcard_verifymsg1: "1. O arquivo deve ter menos de 8M. As informações no documento devem estar claramente visíveis, sem modificações ou objetos cobrindo, e o número do documento e o nome devem ser visíveis.",
            idcard_verifymsg2: "2. A fotografia deve mostrar você sem chapéu. É recomendável que não use maquiagem. As características faciais do portador do documento devem ser claras, e os braços devem estar completamente expostos.",
            idcard_verifymsg3: "3. É necessário segurar ambos os documentos em mãos e uma cópia manuscrita (nome + data da solicitação), 'Todas as minhas ações neste site são minhas próprias operações, e entendo os riscos envolvidos e estou disposto a assumir todas as consequências legais desta conta.'"
        },
        account: {
            pagetitle: "Vincular conta com nome real",
            pagetip: "Por favor, defina seu método de pagamento, certifique-se de usar minha conta com nome real",
            backcardno: "Conta bancária",
            backcardtip: "Informações da conta bancária pessoal não vinculadas",
            modify: "Modificar",
            bind: "Vincular",
            name: "Nome",
            bankaccount: "Conta bancária",
            bankbranch: "Agência bancária",
            bankno: "Número da conta",
            confirmbankno: "Confirmar número da conta",
            fundpwd: "Senha do fundo",
            save: "Salvar",
            zfbaccount: "Conta do Alipay",
            zfbaccounttip: "Conta pessoal do Alipay não vinculada",
            wxaccount: "Conta do WeChat",
            wxaccounttip: "Conta pessoal do WeChat não vinculada",
            banknomsg1: "Por favor, insira o número correto da conta bancária",
            banknomsg2: "O número da conta bancária inserido duas vezes está inconsistente!",
            verifiedmsg: "Por favor, realize a autenticação de nome real primeiro",
            bankaccountmsg: "Por favor, selecione seu banco",
            bankbranchmsg: "Por favor, insira a agência da conta",
            banknomsg: "Por favor, insira o número correto da conta bancária",
            fundpwdmsg1: "Por favor, insira a senha do fundo correta",
            fundpwdmsg2: "A senha não pode ter menos de 6 caracteres",
            zfbaccountmsg: "Por favor, insira a conta do Alipay",
            wxaccountmsg: "Por favor, insira a conta do WeChat",
            save_success: "Sucesso!",
            save_failure: "Falha!"
        },
        otcorder: {
            unpaid: "Não pago",
            paided: "Pago",
            finished: "Finalizado",
            canceled: "Cancelado",
            appealing: "Em apelação",
            searchtip: "Digite o número do pedido",
            orderno: "Número do Pedido",
            created: "Tempo",
            symbol: "Moeda",
            type: "Tipo",
            type_sell: "venda",
            type_buy: "compra",
            tradename: "Nome do Comércio",
            amount: "Quantia",
            money: "Dinheiro",
            fee: "Taxa"
        },
        identity: {
            certified: "já certificado",
            placeholder: "Por favor, preencha o motivo para o cancelamento",
            apply: "Aplicar para se tornar um comerciante",
            become: "Torne-se um comerciante certificado e aproveite mais privilégios de transação",
            zhusnhu: "Comerciantes desfrutam de estandes exclusivos para aumentar o sucesso das transações",
            tijiaoziliao: "Enviar informações de autenticação do comerciante",
            place: "Por favor, faça o upload das informações de autenticação do comerciante para a plataforma e envie para análise",
            tijiao: "Sua análise de certificação de comerciante foi enviada",
            tijiaosuc: "Parabéns! Sua certificação de comerciante foi aprovada",
            tijiaofail: "Desculpe! Sua certificação de comerciante não foi aprovada",
            zhuxiaotijiao: "Sua solicitação de cancelamento de comerciante foi enviada",
            shenhefail: "Sua solicitação de cancelamento de comerciante não foi aprovada",
            shenhesuc: "Sua solicitação de cancelamento de comerciante foi aprovada",
            shangjiazhuxiao: "cancelamento de comerciante",
            shenagain: "revisar",
            shenheshibai: "Falha na análise",
            sheqinggain: "Para aplicar",
            reason: "motivo",
            shenqingtuibao: "Solicitar empréstimo",
            getquan: "Você tem as seguintes permissões",
            read: "Eu li e concordo",
            lijishenqing: "Aplicar agora",
            tips: "dica",
            wufachexiao: "Você está no processo de cancelamento do comerciante, após confirmar a submissão da operação do pedido, não poderá ser revogado.",
            suredo: "Tem certeza de que deseja concluir?",
            shuzizichan: "Certificado de transação de ativos digitais",
            gerenzichan: "Certificado de ativos digitais pessoais",
            second: {
                line: "Como aplicar para ser comerciante?",
                step1: "Passo 1: prepare os materiais de aplicação conforme necessário",
                step1c1: "Prepare os seguintes documentos:",
                step1c2: "Número de celular, ID do WeChat, número do QQ, certificado de ativos digitais pessoais (imagem), certificado de transação de ativos digitais (imagem)",
                step2: "Passo 2: envie a aplicação",
                step2c: "Preencha os materiais de auditoria de certificação de comerciante necessários e clique em enviar para análise.",
                step3: "Passo 3: análise dos dados",
                stepc: "Estaremos revisando sua aplicação para o comerciante nos próximos três a cinco dias, fique de olho, mas você pode enviar uma página. Após a aprovação, você pode publicar o anúncio na área de câmbio de moeda fiduciária.",
                agree: "Acordado para congelar",
                agreec: "Como depósito do comerciante",
                shenqingchngweishangjia: "Aplicar para comerciante"
            },
            yuanyin: "motivo",
            bizhong: "Moeda do depósito",
            shuliang: "Valor do depósito",
            chosen: "Escolher moeda",
            seat: "Estande exclusivo",
            service: "Serviço individual",
            lowfee: "Taxas mais baixas",
            phone: "Telefone",
            balance: "Ativos pessoais",
            cardphoto: "Foto do documento de identidade",
            wx: "WeChat",
            exchange: "Você realiza transações off-exchange de ativos digitais?",
            handphoto: "Usuário segurando foto do documento de identidade",
            qq: "QQ",
            ploy: "Existe uma estratégia de controle de risco correspondente?",
            agreement: "《Acordo de Comerciante Certificado》",
            applyfor: "Aplicar",
            sendcode: "Enviar código",
            confirm: "Confirmar",
            prepare: "Preparar materiais",
            result: "Aguarde o resultado",
            review: "Submeter para revisão",
            passed: "Revisão aprovada",
            approve: "Por favor, aceite o contrato de comerciante certificado",
            emailtip1: "Por favor, envie os seguintes materiais para",
            emailtip2: "Revisaremos sua solicitação assim que possível."
        },
        extension: {
            title1: "Links de promoção",
            title2: "Promover amigos",
            title3: "Minha comissão",
            linkdesc: "O seguinte URL é seu endereço de promoção para o mundo exterior. Você pode promovê-lo através de amigos, QQ, WeChat, Weibo, blogs, fóruns ou seu próprio site. Todas as pessoas que acessarem através deste endereço serão seus usuários após o registro. E quando esses usuários enviarem estratégias neste site, você pode ganhar comissões, e detalhes da promoção podem ser visualizados no registro de acesso.",
            linktitle: "Seus links de promoção",
            copy: "Copiar",
            copy_msg1: "Cópia bem-sucedida!",
            copy_msg2: "Falha! Por favor, copie manualmente",
            username: "Nome",
            currrecharge: "Transação",
            userlevel: "Nível do usuário",
            createdtime: "Data de registro",
            currcommission: "Comissão atual",
            managerfee: "Taxa de gestão",
            yuan: "yuan (RMB)",
            symbol: "MOEDA",
            amount: "Quantia",
            remark: "Observação",
            amounttime: "Tempo de entrega"
        },
        promotion: {
            title: "Centro de Promoção",
            subtitle1: "Meus Cartões",
            subtitle2: "Registros de Troca",
            subtitle3: "Minha Promoção",
            card_column0: "Código de Troca",
            card_column1: "Nome",
            card_column2: "Símbolo da Moeda",
            card_column3: "Quantia",
            card_column4: "Data Limite",
            card_column5: "Total",
            card_column6: "Trocado",
            card_column7: "Data de Criação",
            my_column0: "Convidar Usuário",
            my_column1: "Data de Registro",
            my_column2: "Nome Real",
            gopromotion: "Promoção",
            inputcardno: "Por favor, insira o código do cartão",
            exchange: "Trocar",
            exchangesuccess: "Parabéns! Você pode verificar o ativo no centro financeiro!",
            exchangewithcode: "Trocar com código"
        },
        activity: {
            navTitle: "Inovação",
            subNavTitle1: "Meus Pedidos",
            subNavTitle2: "Minhas Minerações",
            subNavTitle3: "Meus Bloqueios",
            column1: "Nome",
            column2: "Tipo",
            column3: "Quantia",
            column4: "Unidade (ENT)",
            column5: "Unidade (SAÍDA)",
            column6: "Status",
            column7: "Volume de Negócios",
            column8: "Data de Criação",
            mColumn1: "Imagem",
            mColumn2: "Nome",
            mColumn3: "Unidade da Moeda",
            mColumn4: "Período",
            mColumn5: "Dias de Mineração",
            mColumn6: "Dias Minerados",
            mColumn7: "Status",
            mColumn8: "Capacidade Base",
            mColumn9: "Capacidade Atual",
            mColumn10: "Total Minerado",
            mColumn11: "Data de Término",
            mColumn12: "Data de Criação",
            lColumn1: "Imagem",
            lColumn2: "Nome",
            lColumn3: "Unidade da Moeda",
            lColumn4: "Período",
            lColumn5: "Dias Bloqueados",
            lColumn6: "Dias Liberados",
            lColumn7: "Status",
            lColumn8: "Capacidade Base",
            lColumn9: "Capacidade Atual",
            lColumn10: "Total Liberado",
            lColumn11: "Data de Término",
            lColumn12: "Data de Criação"
        },
        mining: {
            title: "Minha Lista de Mineração",
            empty: "Sem Registros",
            day: "Dia",
            week: "Semana",
            month: "Mês",
            year: "Ano",
            invitetip1: "A capacidade da máquina de mineração pode ser aprimorada convidando amigos. Cada pessoa convidada para trocar a máquina de mineração aumentará a capacidade",
            invitetip2: "Limite superior do aumento de capacidade",
            miningUnit: "Unidade de Mineração",
            miningPeriod: "Período de Mineração",
            miningDays: "Quantos Dias de Mineração",
            miningedDays: "Quantos Dias Minerados",
            miningDaysProfit: "Produção Base",
            miningCurrentDaysProfit: "Produção Atual",
            status0: "A ser implantado",
            status1: "Implantado",
            status2: "Acabado"
        },
        locked: {
            title: "Minha Lista de Bloqueios",
            empty: "Sem Registros",
            day: "Dia",
            week: "Semana",
            month: "Mês",
            year: "Ano",
            invitetip1: "A capacidade do bloqueio pode ser aprimorada convidando amigos. Cada pessoa convidada para trocar o bloqueio aumentará a capacidade",
            invitetip2: "Limite superior do aumento de capacidade",
            miningUnit: "Unidade de Liberação",
            miningPeriod: "Período de Liberação",
            miningDays: "Quantos Dias de Liberação",
            miningedDays: "Quantos Dias Liberados",
            miningDaysProfit: "Produção Base",
            miningCurrentDaysProfit: "Produção Atual",
            status0: "A ser liberado",
            status1: "Liberando",
            status2: "Acabado",
            totallocked: "Total Bloqueado"
        },
        api: {
            apiAdmin: "Gestão de API",
            createApi: "Criar uma nova chave API",
            mark: "Observação",
            bindAddress: "O endereço IP não vinculado da chave é válido por 90 dias",
            hint: "Dica",
            part1: "Nós fornecemos uma API poderosa, você pode usar consulta de mercado, transações automáticas e outros serviços",
            apiDoc: "pela documentação da API.",
            howUse: "Veja como usar",
            part2: "Crie até 5 conjuntos de chaves de API por usuário",
            part3: "Por favor, não divulgue sua chave de API para evitar perdas de ativos. Por questões de segurança, é recomendável vincular o IP à chave API, com um máximo de 5 IPs para cada chave API. Preencha um único endereço diretamente, múltiplos IPs com vírgulas, como 192.168.1.1, 192.168.1.2, em vez de 192.168.1.3.",
            myApiKey: "Minha chave API",
            ipAddress: "Endereço IP",
            createTime: "Hora de Criação",
            accessKey: "Chave de Acesso",
            bindIpAddress: "Vincular Endereço IP",
            ioDays: "Dias restantes",
            operation: "Operação",
            create: "Criar",
            edit: "Editar",
            delete: "Excluir",
            sureDelete: "Tem certeza de que deseja excluir?",
            tips: "A chave só será exibida quando for adicionada, por favor, salve-a a tempo.",
            copy: "Copiar",
            access: "chave",
            okText: "Confirmar",
            cancel: "Cancelar"
        }
    },
    cms: {
        noticecenter: "Central de Avisos",
        newshelp: "Ajuda para Novos Usuários",
        appdownload: "Baixar App",
        onlineservice: "Serviço online",
        faq: "Perguntas Frequentes",
        notice: "Aviso",
        servicecenter: "Centro de Atendimento ao Cliente",
        about: "Sobre",
        joinus: "Junte-se a nós",
        aboutus: "Sobre nós",
        exchangerule: "Regras de Negociação",
        useprotocol: "Acordo de Uso",
        feenote: "Descrição de Taxa",
        merchantprocotol: "Acordo de Comerciante",
        features: "Recursos",
        contactus: "Contato",
        noticelist: "Todos os Avisos",
        nextnotice: "PRÓXIMO",
        prevnotice: "ANTERIOR",
        notexist: "A página que você visitou não existe ou foi excluída",
        otherhelp: "Outros na Categoria",
        scanforshare: "Escanear para compartilhar",
        download: "Baixar",
        downloadslogan: "BIPPAX APP - Compre e negocie em qualquer lugar."
    },
    description: {
        title1: "Segurança",
        title2: "Serviço 24H",
        title3: "Troca Global",
        title4: "Projeto Rigoroso",
        message1: "Sistema completo de controle financeiro e sistema antifurto, carteira quente e fria, sistema de múltiplas assinaturas para garantir a segurança dos fundos",
        message2: "Auditoria manual online 24H pode proteger os clientes de perderem as melhores oportunidades de investimento.",
        message3: "Rede global de serviços de negócios para ajudá-lo a investir em ativos digitais globais e negociar com usuários globais",
        message4: "Selecionamos rigorosamente projetos de blockchain de alta qualidade para filtrar 80% dos projetos de risco extremamente alto para você.",
        scanqrcode: "Baixar APP",
        aboutdesc1: "BIPPAX.PRO é uma plataforma de negociação de ativos digitais líder mundial, registrada nas Ilhas Cayman, com uma equipe central de operações em Hong Kong. Os membros centrais da BIPPAX.PRO vêm de empresas de Internet e financeiras de topo. A maioria deles são grandes crentes no Bitcoin e nas blockchains. Acreditamos que as blockchains mudarão o sistema financeiro tradicional monopolista e construirão uma estrutura social mais democrática e autônoma.",
        aboutdesc2: "A plataforma BIPPAX.PRO possui uma arquitetura de negociação de nível financeiro profissional, um motor de negociação de memória de alta concorrência auto-desenvolvido. A plataforma usa um sistema de carteira totalmente fria + múltiplas assinaturas + sistema de proteção contra ataques DDOS e outras arquiteturas de negociação para garantir a segurança dos ativos dos clientes.",
        aboutdesc3: "Para que os clientes aproveitem melhor as oportunidades de investimento, a BIPPAX.PRO adota uma gestão plana no departamento de atendimento ao cliente e estabelece um mecanismo de resposta de serviço extremamente rápido. O gerente de atendimento ao cliente de ativos está online 7*24H durante todo o ano, fornecendo serviços como recarga e saque de ativos, e garantindo que os clientes completem a recarga em 25 minutos.",
        aboutdesc4: "A BIPPAX.PRO seleciona rigorosamente projetos de alta qualidade e fornece serviços seguros e estáveis de hospedagem de ativos. A BIPPAX.PRO adota o conceito de 'honestidade, justiça, entusiasmo e abertura', esforçando-se para criar uma troca final segura, confiável, eficiente e amigável para os usuários.",
        aboutdesc5: "Embora os ativos digitais estejam apenas em um pequeno círculo agora, acreditamos que esse tipo de ativo, que todos podem controlar plenamente, será popular no futuro. Vamos trabalhar juntos e esperar por isso!",
        support: "Suporte",
        report: "Sugestão",
        service: "Atendimento ao Cliente",
        apply: "Aplicação para Conselho",
        coop: "Cooperação",
        community: "Comunidade BIPPAX",
        wechat: "WeChat",
        addwechat: "Adicione 'coinex' como amigos no WeChat e depois entre na comunidade do WeChat",
        weibo: "Weibo",
        twitter: "Twitter",
        biyong: "Biyong",
        telegram: "Telegram",
        medium: "Medium",
        reddit: "Reddit"
    },
    bzb_description: {
        title1: "",
        title2: "",
        title3: "",
        title4: "",
        title5: "",
        title6: "",
        title7: "",
        title8: "",
        desc1: "",
        desc2: "",
        desc3: "",
        desc4: "",
        desc5: "",
        desc6: "",
        desc7: "",
        desc8: ""
    },
    footer: {
        wechatkefu: "Atendimento WeChat",
        notice: "Aviso",
        gsmc: "Troque a Melhor Criptomoeda",
        bah: "No. 13026899 -3, Shanghai ICP",
        gsjj: "Perfil",
        gywm: "Sobre nós",
        jrwm: "Junte-se a nós",
        biyong: "BiYong",
        lxwm: "Entre em contato conosco",
        yqlj: "Links",
        bzzx: "Ajuda",
        xsrm: "Curso para Iniciantes",
        czzn: "Guia de Recarga",
        jyzn: "Guia de Negociação",
        ptsm: "Explicação",
        fysm: "Taxas",
        fwtk: "Política de Serviço",
        fltk: "Política Legal",
        wechat: "Atendimento WeChat",
        xszn: "Guia para Iniciantes",
        cjwt: "Perguntas Frequentes",
        mztk: "Isenção de Responsabilidade",
        ystk: "Política de Privacidade",
        tkxy: "Condições",
        gybzb: "Sobre BZB",
        kfyx: "E-mail de Serviço",
        swhz: "Cooperação",
        sbsq: "Aplicação de Mercado",
        jyzn: "Guia de Troca",
        bzzl: "Info da Moeda",
        tsjb: "Relatar",
        apidoc: "Documentação da API",
        zwkf: "Em breve"
    },
    index: {
        circulation: "Circulação do fundo de segurança e desenvolvimento",
        hourEth: "Receita acumulada a ser distribuída hoje",
        yesterdayEth: "Receita acumulada a ser distribuída ontem",
        yesterday: "Produção de mineração do dia anterior:",
        bhbTotal: "Fluxo Total de BHB",
        bhbSecond: "Circulação de mercado de dois níveis do BHB",
        checkMineprinciple: "Ver princípio de mineração",
        checkFlowVolum: "Inspecionar circulação",
        checkLockPosition: "Verificar situação de bloqueio",
        BHBregister: "Registro de conta BIPPAX",
        tibi: "Tempo e limite de pagamento para a fatura",
        line_plane: "Anúncio sobre o plano online do BHB, circulação e devolução de taxas de serviço",
        fenpeijizhi: "Descrição do mecanismo de distribuição de receita da BIPPAX",
        jiangli_jihua: "Plano de Premiação para Convidar para Mineração",
        friend_fanhuan: "Convide amigos, ganhe taxa extra e devolução"
    },
    plate: {
        title: "Plano de distribuição de receita da plataforma（Equidade dos detentores de BHB）",
        content1: "Como descrito no white paper, a BIPPAX distribuirá 80% da receita da plataforma (após deduzir impostos e taxas) para os detentores de BHB, e 20% da receita será usada para apoiar P&D e operação da plataforma.",
        content2: "A distribuição de receita ocorre em ciclos diários, sendo o dia 6 de junho de 2018 o primeiro dia de distribuição. Após isso, todos os dias, a receita acumulada do dia anterior será distribuída entre os detentores de BHB proporcionalmente.",
        content3: "(aviso: 1. o BHB aqui refere-se ao BHB que foi liberado/circulado. Veja também【",
        content3_1: "Nota sobre a proporção da circulação de BHB/participação na distribuição de receita",
        content3_2: "2. A distribuição de receita é realizada uma vez por dia, após a captura da instantânea de cada hora (ponto inteiro).",
        hourFenpei: "Distribuição de receita de hoje",
        hourTotal: "Total de receita da plataforma hoje",
        xiangqing: "Detalhes da distribuição de receita de hoje",
        yesterdaytit: "Distribuição de receita de ontem",
        yesterdaytotal: "Total de receita de ontem da plataforma",
        yesterdayxiangqing: "Detalhes da distribuição de receita de ontem",
        yesterday: {
            total: "Total de Receitas",
            allocated: "Receitas Não Distribuídas"
        }
    },
    feereturn: {
        ruletitle: "Nota",
        rulecontent: "Nosso White Paper explica detalhadamente o Reembolso de Taxas de Transação. No geral, 51% da base total de BHB da plataforma (referido como 'parte da recompensa da comunidade' daqui para frente) será reembolsado aos usuários ao longo do tempo através do nosso mecanismo 'Trans-Fee Mining'. Contudo, uma vez que os 51% do total de BHBs tenha sido totalmente liberado por meio de reembolsos, o mecanismo 'Trans-Fee Mining' terminará automaticamente.",
        recordtitle: "Lista",
        recordcontent: "Todos os dias (UTC+8, como abaixo), BHB reembolsará 100% das taxas de transação dos usuários incorridas no dia anterior, na forma de BHB. Isso será feito utilizando o preço médio de BHB do dia anterior (este preço médio é calculado como o valor total transacionado / volume total transacionado). Completaremos este reembolso das taxas de transação do dia anterior em forma de BHBs, às 11h de todos os dias.",
        time: "Data",
        todaycharge: "Preço médio (ETH)",
        totalChange: "Total (ETH)",
        returnCharge: "Reembolso de Trans-Fee Mining (BHB)",
        todayChargeReturn: "Programa de Incentivo para Reembolso FCoin (BHB)"
    },
    home: {
        login: {
            title: "Comece a negociar criptomoedas",
            desc: "Suporte para mais de 500 criptomoedas e uma variedade de ferramentas de negociação",
            btnText: "Negociar agora"
        },
        unlogin: {
            title: "Comece sua jornada com ativos digitais",
            desc: "Registre-se e aproveite o pacote de presentes para novos usuários",
            placinfo: "Telefone/Email",
            btnText: "Registrar"
        },
        WelfareCenter: "Centro de Benefícios",
        Welcome_ceremony: "Presente para Novos Usuários",
        Airdrop: "Airdrop",
        DailyGain: "Recompensas Diárias",
        AirdropGift: "Presentes de Airdrop",
        financial_management: "Gestão Financeira Otimizada",
        Zhoude: "Recompensas Semanais",
        height_is: "até",
        Happiness: "Carnaval da Fortuna",
        Monthly: "Recompensas Mensais",
        CarveUp: "Fundo de Prêmios",
        download: {
            transactions_anytime: "Negocie a qualquer hora, em qualquer lugar",
            scan_code: "Escaneie para Baixar",
            download_more: "Baixar mais"
        },
        brand: {
            digital_platform: "Plataforma de negociação de ativos digitais líder",
            rich_digital: "Serviços ricos de negociação de ativos digitais e gestão de ativos para atender às diversas necessidades de negociação",
            High_quality_digital: "Ativos digitais de alta qualidade",
            Turnover: "Volume de Negócios",
            safety_risk: "Sistema de segurança e gestão de riscos de classe mundial",
            multi_factor: "Armazenamento offline, criptografia multifatorial, monitoramento da plataforma 24/7, proteção abrangente da segurança dos ativos do usuário",
            Security_reserve: "Fundo de Reserva de Segurança",
            accident: "0 acidentes em 9 anos",
            safetyrisk: "Segurança e controle de riscos de nível superior",
            choice_trusted: "A escolha confiada por milhões de usuários",
            transaction_service: "Centros de serviço de transação localizados em vários países e regiões ao redor do mundo, criando um ecossistema blockchain com várias formas de negócios",
            ten_thousand: "10.000",
            User_preference: "Preferido pelos usuários",
            Countries_covered: "Países cobertos"
        },
        trading: {
            digital_currency: "Comece sua jornada com ativos digitais",
            register: "Registrar",
            login: "Entrar",
            currency_transaction: "Comece a negociar criptomoedas",
            to_trade: "Negociar agora"
        }
    }

}



// WEBPACK FOOTER //
// ./src/assets/lang/pt/index.js